// 价格频道：香港繁体中文字段。只维护显示文案，不改业务标识、数值或提交内容。

// 业务状态与选项
export const businessDisplay = Object.freeze({
  "priceChannel.businessDisplay.sourceObservationBasis":
    "來源觀測：實際批組報價相對首個歷史節點的變化（基期=100），不是獨立發佈指數。",
  "priceChannel.businessDisplay.publishedIndexMissing":
    "當前版本尚無此產品的已發佈綜合指數；可選擇來源查看已有報價歷史。",
  "priceChannel.businessDisplay.observationEventsOnly":
    "以下為已發佈報價觀測記錄；新聞事件與外部公告尚未遷入。",
  "priceChannel.businessDisplay.publishedTrendSummary":
    "當前7D窗口 {count} 個已發佈指數點；固定版本：{version}",
  "priceChannel.businessDisplay.publishedCoverageSummary":
    "{specs} 項規格 · {sources} 個來源 · {batches} 個庫存批組",
  "priceChannel.businessDisplay.announcementsNotPublished":
    "當前版本尚未發佈外部研究報告或來源公告，不使用空模板冒充正文。",
  "priceChannel.businessDisplay.latestSourceCoverageBasis":
    "覆蓋矩陣依據各批組最新已發佈觀測日期；不是全歷史覆蓋率。",
  "priceChannel.businessDisplay.inventoryEventStatus.VALID": "有效",
  "priceChannel.businessDisplay.inventoryEventStatus.EXPIRED": "已過期",
  "priceChannel.businessDisplay.inventoryEventStatus.WITHDRAWN": "已撤回",
  "priceChannel.businessDisplay.condition.NEW": "全新",
  "priceChannel.businessDisplay.condition.OPEN_BOX_NEW": "拆包全新",
  "priceChannel.businessDisplay.condition.OPEN_BOX": "拆包",
  "priceChannel.businessDisplay.condition.UNVERIFIED": "待核驗",
  "priceChannel.businessDisplay.packaging.ESD_TRAY": "防靜電托盤",
  "priceChannel.businessDisplay.packaging.WAFER_BOX": "晶圓盒",
  "priceChannel.businessDisplay.packaging.FACTORY_TRAY": "原廠托盤",
  "priceChannel.businessDisplay.packaging.RETAIL_BOX": "零售盒",
  "priceChannel.businessDisplay.packaging.ESD_BAG": "防靜電袋",
  "priceChannel.businessDisplay.packaging.RETAIL_BLISTER": "零售吸塑包裝",
  "priceChannel.businessDisplay.unit.PCS": "件",
  "priceChannel.businessDisplay.unit.WAFER": "片（晶圓）",
  "priceChannel.businessDisplay.dateCode": "日期代碼（Date Code）",
  "priceChannel.businessDisplay.quoteAwaitingTarget": "等待目標價 / 詢價",
  "priceChannel.businessDisplay.quoteNeedsDetails": "報價條件待補充",
  "priceChannel.businessDisplay.currencyPending": "貨幣待補充",
  "priceChannel.businessDisplay.companyTranslationReference":
    "參考譯名，僅供展示；法定名稱以原文為準",
  "priceChannel.businessDisplay.subject.BRAND": "品牌",
  "priceChannel.businessDisplay.subject.CHANNEL": "渠道",
  "priceChannel.businessDisplay.subject.ENTERPRISE": "企業",
  "priceChannel.businessDisplay.subject.ORGANIZATION": "組織",
  "priceChannel.businessDisplay.subject.XSOU": "先搜",
  "priceChannel.businessDisplay.status.DRAFT": "草稿",
  "priceChannel.businessDisplay.status.SUBMITTED": "已提交",
  "priceChannel.businessDisplay.status.UNDER_REVIEW": "審核中",
  "priceChannel.businessDisplay.status.PENDING": "待處理",
  "priceChannel.businessDisplay.status.LEADER_PENDING": "待領導終審",
  "priceChannel.businessDisplay.status.RETURNED": "已退回",
  "priceChannel.businessDisplay.status.REJECTED": "已拒絕",
  "priceChannel.businessDisplay.status.APPROVED": "已通過",
  "priceChannel.businessDisplay.status.PUBLISHING": "發佈中",
  "priceChannel.businessDisplay.status.CALCULATING": "計算中",
  "priceChannel.businessDisplay.status.PUBLISHED": "已發佈",
  "priceChannel.businessDisplay.status.PUBLISH_FAILED": "發佈失敗",
  "priceChannel.businessDisplay.status.CALCULATION_FAILED": "行情計算失敗",
  "priceChannel.businessDisplay.status.FAILED": "失敗",
  "priceChannel.businessDisplay.status.ACTIVE": "有效",
  "priceChannel.businessDisplay.stage.DEPARTMENT": "部門審核",
  "priceChannel.businessDisplay.stage.LEADER": "領導終審",
  "priceChannel.businessDisplay.stage.OPERATIONS": "運營審核",
  "priceChannel.businessDisplay.decision.APPROVE": "通過",
  "priceChannel.businessDisplay.decision.RETURN": "退回",
  "priceChannel.businessDisplay.decision.REJECT": "拒絕",
  "priceChannel.businessDisplay.outcome.SUCCEEDED": "成功",
  "priceChannel.businessDisplay.outcome.FAILED": "失敗",
  "priceChannel.businessDisplay.certification.SELF_OWNED_BRAND": "自有品牌",
  "priceChannel.businessDisplay.certification.AUTHORIZED_PLATFORM": "授權平台",
  "priceChannel.businessDisplay.certification.PARTNER_CHANNEL": "合作渠道",
  "priceChannel.businessDisplay.qualificationType.enterpriseProfile":
    "企業主體資料",
  "priceChannel.businessDisplay.qualificationType.other": "其他價格指數資料",
  "priceChannel.businessDisplay.qualificationMeta.fileName": "檔案名稱",
  "priceChannel.businessDisplay.qualificationMeta.extension": "擴展名",
  "priceChannel.businessDisplay.qualificationMeta.size": "檔案大小",
  "priceChannel.businessDisplay.qualificationMeta.selectedAt": "選擇時間",
  "priceChannel.businessDisplay.qualificationMeta.demoAttachmentId": "附件標識",
  "priceChannel.businessDisplay.category.flash-wafer": "快閃記憶體晶圓",
  "priceChannel.businessDisplay.category.memory-wafer": "記憶體晶圓",
  "priceChannel.businessDisplay.category.flash-chip": "快閃記憶體晶片",
  "priceChannel.businessDisplay.category.memory-chip": "記憶體晶片",
  "priceChannel.businessDisplay.category.memory-module": "記憶體模組",
  "priceChannel.businessDisplay.category.solid-state-drive": "固態硬碟",
  "priceChannel.businessDisplay.category.flash-card": "快閃記憶體卡",
  "priceChannel.businessDisplay.category.embedded-storage": "嵌入式儲存器",
  "priceChannel.businessDisplay.category.usb-flash-drive": "USB快閃記憶體盤",
  "priceChannel.businessDisplay.dimension.wafer-device-kind": "類型",
  "priceChannel.businessDisplay.dimension.flash-memory-kind": "類型",
  "priceChannel.businessDisplay.dimension.flash-cell-type": "製程",
  "priceChannel.businessDisplay.dimension.dram-generation": "代際",
  "priceChannel.businessDisplay.dimension.bit-density-gbit": "容量",
  "priceChannel.businessDisplay.dimension.byte-capacity-gbyte": "容量",
  "priceChannel.businessDisplay.dimension.clock-mhz": "頻率",
  "priceChannel.businessDisplay.dimension.data-rate-mtps": "速率",
  "priceChannel.businessDisplay.dimension.bus-width": "位寬",
  "priceChannel.businessDisplay.dimension.organization": "組織",
  "priceChannel.businessDisplay.dimension.stack-layer-count": "層數",
  "priceChannel.businessDisplay.dimension.wafer-diameter-mm": "直徑",
  "priceChannel.businessDisplay.dimension.interface-rate-mtps": "速率",
  "priceChannel.businessDisplay.dimension.package": "封裝",
  "priceChannel.businessDisplay.dimension.package-structure": "結構",
  "priceChannel.businessDisplay.dimension.protocol-version": "協議",
  "priceChannel.businessDisplay.dimension.interface-generation": "介面",
  "priceChannel.businessDisplay.dimension.form-factor": "形態",
  "priceChannel.businessDisplay.dimension.ecc-capability": "ECC",
  "priceChannel.businessDisplay.dimension.rank": "Rank",
  "priceChannel.businessDisplay.dimension.speed-class": "等級",
  "priceChannel.businessDisplay.value.bare-die": "裸Die",
  "priceChannel.businessDisplay.value.packaged-ic": "封裝顆粒",
  "priceChannel.businessDisplay.value.not-applicable": "不適用",
  "priceChannel.businessDisplay.value.single-die": "單Die",
  "priceChannel.businessDisplay.value.multi-die": "多Die",
  "priceChannel.businessDisplay.value.2.5-inch": "2.5英寸",
  "priceChannel.businessDisplay.value.consumer": "消費級",
  "priceChannel.businessDisplay.value.enterprise": "企業級",
  "priceChannel.businessDisplay.value.secondary-market": "二級市場",
  "priceChannel.businessDisplay.value.managed-package": "管理封裝",
  "priceChannel.businessDisplay.value.usb-mass-storage": "USB大容量儲存",
  "priceChannel.businessDisplay.value.high-speed": "高速",
  "priceChannel.businessDisplay.value.usb-flash-drive": "USB閃存盤",
  "priceChannel.businessDisplay.formInvalid": "表單內容無效，請檢查各字段",
  "priceChannel.businessDisplay.reviewInvalid":
    "審核內容無效，請核對意見與版本後重試",
  "priceChannel.businessDisplay.originalContentHint":
    "下方用戶填寫的內容及審核意見為原文；切換界面語言不會改寫原始記錄。",
  "priceChannel.businessDisplay.validation.array": "{field}需要填寫為數組",
  "priceChannel.businessDisplay.validation.arrayLimit": "{field}最多填寫100項",
  "priceChannel.businessDisplay.validation.fileId": "第{index}項缺少檔案ID",
  "priceChannel.businessDisplay.validation.arrayEntry": "第{index}項格式無效",
  "priceChannel.businessDisplay.validation.text": "{field}必須填寫文字",
  "priceChannel.businessDisplay.validation.arrayRequired":
    "第{index}項缺少{field}",
  "priceChannel.businessDisplay.validation.dimensionValue":
    "第{index}項缺少規格值或選項ID",
  "priceChannel.businessDisplay.validation.decimal":
    "{field}{location}必須是非負十進制數",
  "priceChannel.businessDisplay.validation.currency":
    "第{index}項幣種須為三位大寫代碼",
  "priceChannel.businessDisplay.validation.required": "請填寫{field}",
});

// 行情界面
export const market = Object.freeze({
  "priceChannel.title": "價格指數",
  "priceChannel.channelName": "價格頻道",
  "priceChannel.market": "行情",
  "priceChannel.categories": "分類",
  "priceChannel.watchlist": "自選",
  "priceChannel.my": "我的",
  "priceChannel.personalNavigation": "價格頻道個人中心導航",
  "priceChannel.messageCenter": "訊息中心",
  "priceChannel.primaryNavigation": "價格頻道主導航",
  "priceChannel.marketNavigation": "價格指數導航",
  "priceChannel.navigationHint": "單擊恢復上次位置，雙擊刷新當前頁面",
  "priceChannel.brandFilter": "品牌",
  "priceChannel.marketFilter": "正式版行情產品分類與品牌篩選",
  "priceChannel.categoryHeading": "分類行情",
  "priceChannel.productCategory": "產品分類",
  "priceChannel.applicationReview": "申報審核",
  "priceChannel.applicationReviewCount": "申報審核 ({count})",
  "priceChannel.invalidRegionRoute":
    "URL中的地區無法識別，請清除地區或重新選擇；未擴大到全部來源。",
  "priceChannel.invalidCategoryRoute":
    "URL中的產品分類無法識別，請重新選擇產品大類。",
  "priceChannel.regionLoadFailed": "地區報價載入失敗，請重新選擇地區。",
  "priceChannel.categoryDescription":
    "選擇一個產品大類，再按任意維度逐步收窄行情範圍。",
  "priceChannel.viewMultidimensional": "查看多維行情",
  "priceChannel.myWatchlist": "我的自選",
  "priceChannel.myFavorites": "我的收藏",
  "priceChannel.itemsCount": "{count} 項",
  "priceChannel.viewAll": "查看全部",
  "priceChannel.noFavorites": "還沒有收藏",
  "priceChannel.favoritesHint":
    "點擊行情卡片右上角的“＋”，把關注對象放到這裏。",
  "priceChannel.allBrands": "全部品牌",
  "priceChannel.marketOverview": "市場概覽",
  "priceChannel.levelOneMarket": "一級行情",
  "priceChannel.sampleSources": "{samples} 樣本 · {sources} 來源",
  "priceChannel.marketMovers": "行情異動",
  "priceChannel.mover.positive": "漲跌幅降序",
  "priceChannel.mover.negative": "漲跌幅升序",
  "priceChannel.mover.latest": "最新更新",
  "priceChannel.noMatchingMarket": "當前頻道暫無對應行情",
  "priceChannel.hotDiscovery": "熱門發現",
  "priceChannel.hotDiscoveryTypes": "熱門發現類型",
  "priceChannel.popularMarkets": "熱門行情",
  "priceChannel.popularProducts": "熱門產品",
  "priceChannel.multidimensionalMarket": "多維行情",
  "priceChannel.regionalHotProducts": "多地區熱門產品",
  "priceChannel.brandActivity": "品牌活躍",
  "priceChannel.productCategories": "{products} 個產品 · {categories} 個分類",
  "priceChannel.updatedAt": "更新 {time}",
  "priceChannel.sourceActivity": "來源動態",
  "priceChannel.registeredSources": "{count} 個登記來源",
  "priceChannel.recentAt": "最近 {time}",
  "priceChannel.majorPlatform": "大型平台",
  "priceChannel.partnerChannel": "合作渠道",
  "priceChannel.marketPerformance": "市場表現",
  "priceChannel.regionFilter": "報價來源地區篩選",
  "priceChannel.noMatchingRegion": "沒有匹配地區",
  "priceChannel.region.country": "國家",
  "priceChannel.region.admin": "省/州",
  "priceChannel.region.city": "城市",
  "priceChannel.currentNext": "當前為{current}，點擊切換為{next}",
  "priceChannel.next": "點擊切換為{next}",
  "priceChannel.sort.DEFAULT": "預設報價",
  "priceChannel.sort.VALUE": "最優報價",
  "priceChannel.sort.VALUE.basis":
    "按綜合指數從低到高排列，並非實時最低可成交報價",
  "priceChannel.sort.LATEST": "最新報價",
  "priceChannel.view.charts": "圖表",
  "priceChannel.view.list": "列表",
  "priceChannel.multidimensionalFilter": "多維行情篩選",
  "priceChannel.addFavorite": "加入收藏",
  "priceChannel.chooseWatchlist": "請選擇自選分組",
  "priceChannel.watchlistAdded": "已加入自選",
  "priceChannel.watchlistManage": "管理全部自選",
  "priceChannel.watchlistSignIn": "登入後可查看自己的自選行情。",
  "priceChannel.removeFavorite": "取消收藏",
  "priceChannel.searchResultsFor": "{name}搜索結果",
  "priceChannel.selectionPath": "當前行情分類路徑",
  "priceChannel.emptyScopeTitle": "當前恢復條件已無可用產品",
  "priceChannel.emptyScopeHint":
    "保留原篩選條件，移除失效條件後可繼續查看行情。",
  "priceChannel.removeCondition": "移除{condition}",
  "priceChannel.dimension": "維度",
  "priceChannel.cachedCondition": "緩存條件",
  "priceChannel.condition": "條件",
  "priceChannel.unknown": "未知",
  "priceChannel.regionRelated": "地區相關",
  "priceChannel.regionRelatedGroup": "地區相關：{name}",
  "priceChannel.regionRelatedLoadRetry": "地區行情載入失敗，點擊重試",
  "priceChannel.regionRelatedPreparing": "正在整理相關地區…",
  "priceChannel.hidePageArrows": "隱藏組內翻頁箭頭",
  "priceChannel.showPageArrows": "顯示組內翻頁箭頭",
  "priceChannel.batchPending": "批次待核驗",
  "priceChannel.availableQuantity": "可售數量",
  "priceChannel.fabricationInfo": "出廠資料",
  "priceChannel.packaging": "包裝",
  "priceChannel.conditionLabel": "貨況",
  "priceChannel.stockLocation": "庫存地點",
  "priceChannel.minimumOrderQuantity": "最小起訂量",
  "priceChannel.deliveryLeadTime": "交期",
  "priceChannel.quantityTiers": "數量階梯",
  "priceChannel.noQuantityTiers": "當前報價未提供數量階梯",
  "priceChannel.quoteHistory": "報價歷史",
  "priceChannel.status.ACTIVE": "有效",
  "priceChannel.status.EXPIRED": "已過期",
  "priceChannel.status.SOLD_OUT": "已售罄",
  "priceChannel.status.WITHDRAWN": "已撤回",
  "priceChannel.resolution.EXACT": "批次明確",
  "priceChannel.resolution.PROBABLE": "推定歸併",
  "priceChannel.resolution.UNKNOWN": "資料待補",
  "priceChannel.quoteSource": "報價來源",
  "priceChannel.sourceBatches": "來源與批組",
  "priceChannel.partBatches": "料號與批組",
  "priceChannel.switchToSources": "切換為報價來源瀏覽",
  "priceChannel.switchToParts": "切換為標準料號瀏覽",
  "priceChannel.batchSourceCount": "{batches} 個批組 · {sources} 個來源",
  "priceChannel.partActiveCount": "{parts} 個料號 · {active}/{total} 個有效",
  "priceChannel.noValidQuote": "暫無有效報價",
  "priceChannel.none": "暫無",
  "priceChannel.quantityUnknown": "數量未知",
  "priceChannel.timePending": "時間待補充",
  "priceChannel.realtimeQuotes": "實時報價",
  "priceChannel.sourceCount": "{count} 個來源",
  "priceChannel.currentQuote": "當前報價 / TP",
  "priceChannel.productionMark": "生產標記",
  "priceChannel.moq": "MOQ",
  "priceChannel.latestTime": "最新時間",
  "priceChannel.noApprovedQuotes": "當前暫無已審核報價",
  "priceChannel.coverageMatrix": "來源覆蓋矩陣",
  "priceChannel.coverageHint": "來源與日期覆蓋情況",
  "priceChannel.source": "來源",
  "priceChannel.covered": "已覆蓋",
  "priceChannel.noCoverage": "暫無來源覆蓋資料",
  "priceChannel.multiSeriesTrend": "行情標的多序列趨勢圖",
  "priceChannel.noChartData": "當前暫無可展示數據",
  "priceChannel.pendingDetail": "待補充",
  "priceChannel.indexTrend": "行情指數趨勢",
  "priceChannel.pointAria": "{name}，{time}，指數{value}",
  "priceChannel.dailyClose": "收盤 {close} · 昨收 {previous} · 日漲跌 {change}",
  "priceChannel.sourceVisibility": "趨勢來源顯示控制",
  "priceChannel.hideAll": "取消全部",
  "priceChannel.showAll": "展示全部",
  "priceChannel.sectorIndex": "{name}行情指數",
  "priceChannel.sectorTrend": "{name}行情指數趨勢",
  "priceChannel.indexPeriod": "行情指數週期",
  "priceChannel.customRangeFailed": "無法應用該時間範圍",
  "priceChannel.industryScope": "行業相關行情範圍",
  "priceChannel.dimensionCandidates": "{name}候選值",
  "priceChannel.technicalCandidates": "技術族候選值",
  "priceChannel.backHome": "返回行情首頁",
  "priceChannel.dataCutoff": "數據截止 {time}",
  "priceChannel.backCategory": "返回分類",
  "priceChannel.retry": "重試",
  "priceChannel.loadingRelease": "正在讀取當前行情版本…",
  "priceChannel.currentScope": "當前板塊",
  "priceChannel.relatedProducts": "{count} 個相關產品",
  "priceChannel.scopeTrend": "當前板塊指數趨勢",
  "priceChannel.scopePending": "當前篩選範圍正在計算，尚未進入公開行情版本。",
  "priceChannel.scopeRecovering":
    "計算等待較久，當前頁每 10 秒檢查一次；已有內容仍可使用。",
  "priceChannel.scopeRecoveryStopped":
    "本次自動檢查已結束，計算可能仍在後台進行；可重試查詢狀態。",
  "priceChannel.relationRecoveryStopped":
    "部分關聯曲線仍未就緒，自動補讀已結束；重試只補缺失曲線。",
  "priceChannel.scopeFailed": "當前篩選範圍計算未完成，請稍後重試。",
  "priceChannel.scopeEmpty": "當前範圍暫無可展示的產品指數。",
  "priceChannel.categoryEmpty": "當前分類暫無可展示的行情。",
  "priceChannel.loadingMore": "正在載入…",
  "priceChannel.loadMore": "載入更多",
  "priceChannel.instrumentIndex": "具體產品指數",
  "priceChannel.instrument": "具體產品",
  "priceChannel.instrumentTrend": "{name}指數趨勢",
  "priceChannel.instrumentEmpty": "該產品當前版本暫無指數點。",
  "priceChannel.partNumbers": "料號",
  "priceChannel.partNumbersEmpty": "當前版本暫無公開料號。",
  "priceChannel.compositeIndex": "綜合指數",
  "priceChannel.missing": "缺失",
  "priceChannel.pending": "待確認",
  "priceChannel.product": "產品",
  "priceChannel.serviceUnavailable": "價格頻道服務暫不可用，請稍後重試。",
  "priceChannel.releaseExpired": "當前行情版本已過期，請重新載入。",
  "priceChannel.viewForbidden": "當前身份沒有查看此數據的權限。",
  "priceChannel.loadFailed": "行情讀取失敗，請稍後重試。",
  "priceChannel.identityRestoring": "正在恢復價格頻道身份…",
  "priceChannel.businessEyebrow": "我的 · 價格頻道",
  "priceChannel.viewMarket": "查看行情指數",
  "priceChannel.identityChecking": "正在確認當前賬號的價格頻道身份…",
  "priceChannel.currentAccount": "當前商城賬號",
  "priceChannel.account": "賬號 {id}",
  "priceChannel.identity": "價格頻道身份",
  "priceChannel.noIdentity": "此商城賬號尚無有效價格頻道身份。",
  "priceChannel.authorizedScopes": "{count} 個獲授權主體範圍",
  "priceChannel.businessNavigation": "價格頻道業務",
  "priceChannel.businessForbidden": "當前身份沒有此業務入口權限。",
  "priceChannel.backIdentity": "返回頻道身份",
  "priceChannel.availableBusiness": "當前可用業務",
  "priceChannel.bindIdentity":
    "請先由業務管理員給當前商城賬號綁定有效會員身份。",
  "priceChannel.noBusiness": "當前身份暫無可操作的價格頻道業務。",
  "priceChannel.refresh": "刷新",
  "priceChannel.reading": "正在讀取…",
  "priceChannel.noRecords": "當前沒有相關記錄。",
  "priceChannel.watchlistItems": "{count} 項自選",
  "priceChannel.memberIdentity": "會員身份",
  "priceChannel.section.identity": "頻道身份",
  "priceChannel.section.activity": "訊息中心",
  "priceChannel.section.watchlists": "行情自選",
  "priceChannel.section.certifications": "企業認證",
  "priceChannel.section.submissions": "業務上報",
  "priceChannel.section.reviews": "審核待辦",
  "priceChannel.section.results": "審查結果",
  "priceChannel.activity.all": "全部",
  "priceChannel.activity.market": "行情關注",
  "priceChannel.activity.inventory": "料號 / 庫存",
  "priceChannel.activity.workflow": "業務流程",
  "priceChannel.activity.system": "系統",
  "priceChannel.activityProjectionHint":
    "僅彙總當前身份可讀的上報與待審狀態；這是活動投影，不是已推送通知。",
  "priceChannel.activitySourceUnavailable":
    "該類通知尚無正式事件介面，當前不展示模擬訊息。",
  "priceChannel.watchlistName": "自選分組名稱",
  "priceChannel.createWatchlist": "創建分組",
  "priceChannel.removeWatchlistItem": "移除自選項",
  "priceChannel.invalidSelection":
    "原鏈接中的部分篩選條件未能映射到當前發佈目錄，請重新選擇。",
  "priceChannel.loginExpired": "登入已失效，請重新登入。",
  "priceChannel.accountForbidden": "當前賬號或身份沒有訪問權限。",
  "priceChannel.businessUnavailable": "價格頻道業務服務暫不可用，請稍後重試。",
  "priceChannel.readFailed": "讀取失敗，請稍後重試。",
  "priceChannel.role.platform_leader": "平台領導",
  "priceChannel.role.company_business": "企業業務",
  "priceChannel.role.company_operations": "企業運營",
  "priceChannel.role.self_owned_brand": "自有品牌",
  "priceChannel.role.authorized_platform": "授權平台",
  "priceChannel.role.partner_channel": "合作渠道",
  "priceChannel.role.readonly_customer": "只讀客戶",
  "priceChannel.submissions": "業務上報",
  "priceChannel.submission.PRODUCT": "具體產品",
  "priceChannel.submission.PART_NUMBER": "標準料號",
  "priceChannel.submission.INVENTORY": "庫存批組",
  "priceChannel.submission.OFFER": "報價觀察",
  "priceChannel.field.instrumentId": "具體產品 ID",
  "priceChannel.field.partNumberId": "標準料號 ID",
  "priceChannel.field.categoryId": "分類 ID *",
  "priceChannel.field.brandRef": "品牌引用 *",
  "priceChannel.field.code": "產品代碼 *",
  "priceChannel.field.title": "產品名稱 *",
  "priceChannel.field.instrumentKind": "產品類型 *",
  "priceChannel.field.dimensions": "技術維度",
  "priceChannel.field.evidenceRefs": "證明檔案引用",
  "priceChannel.field.manufacturerPartNumber": "原廠料號 *",
  "priceChannel.field.attributes": "料號屬性",
  "priceChannel.field.batchId": "庫存批組 ID",
  "priceChannel.field.sourceProviderId": "報價來源 ID *",
  "priceChannel.field.batchCode": "批次代碼",
  "priceChannel.field.dateCode": "Date Code",
  "priceChannel.field.originRegionId": "出廠地區 ID",
  "priceChannel.field.stockRegionId": "庫存地區 ID",
  "priceChannel.field.packaging": "包裝",
  "priceChannel.field.condition": "貨況",
  "priceChannel.field.stockQuantity": "庫存數量 *",
  "priceChannel.field.quantityUnit": "數量單位 *",
  "priceChannel.field.minimumOrderQuantity": "最小訂購量",
  "priceChannel.field.inventoryBatchId": "庫存批組 ID *",
  "priceChannel.field.amount": "單價 *",
  "priceChannel.field.currency": "幣種 *",
  "priceChannel.field.priceUnit": "報價單位 *",
  "priceChannel.field.observedAt": "報價時間（ISO 8601）*",
  "priceChannel.field.expiresAt": "有效期（ISO 8601）",
  "priceChannel.field.sourceRecordId": "來源記錄 ID",
  "priceChannel.field.sourceRevision": "來源修訂",
  "priceChannel.field.tiers": "數量階梯",
  "priceChannel.array.dimensionId": "維度 ID *",
  "priceChannel.array.optionId": "選項 ID",
  "priceChannel.array.normalizedValue": "規格值",
  "priceChannel.array.unit": "單位",
  "priceChannel.array.attributeCode": "屬性代碼 *",
  "priceChannel.array.label": "屬性名稱",
  "priceChannel.array.value": "屬性值",
  "priceChannel.array.minimumQuantity": "起訂量 *",
  "priceChannel.array.maximumQuantity": "最大數量",
  "priceChannel.array.amount": "單價 *",
  "priceChannel.array.currency": "幣種 *",
  "priceChannel.array.priceUnit": "報價單位 *",
  "priceChannel.array.fileId": "檔案 ID {index}",
  "priceChannel.array.addNamed": "添加{label}",
  "priceChannel.array.remove": "刪除該項",
  "priceChannel.array.removeNamed": "刪除第 {index} 項{label}",
  "priceChannel.field.existingInstrumentId": "已有產品 ID（新建留空）",
  "priceChannel.field.requiredInstrumentId": "具體產品 ID *",
  "priceChannel.field.existingPartNumberId": "已有料號 ID（新建留空）",
  "priceChannel.field.existingBatchId": "已有批組 ID（新建留空）",
  "priceChannel.closeDraft": "收起草稿",
  "priceChannel.newDraft": "新建草稿",
  "priceChannel.draftHint":
    "草稿儲存在業務數據庫，正文由 Platform 儲存為不可變修訂；儲存不會自動送審。",
  "priceChannel.noAuthorizedSubject":
    "當前身份沒有獲授權主體，不能創建業務上報。",
  "priceChannel.subject": "上報主體",
  "priceChannel.chooseSubject": "請選擇獲授權主體",
  "priceChannel.submissionType": "上報類型",
  "priceChannel.saving": "儲存中…",
  "priceChannel.saveDraft": "儲存草稿",
  "priceChannel.saveChanges": "儲存修訂",
  "priceChannel.resumeReturnedDraft": "恢復退回草稿",
  "priceChannel.originalSubmissionFields": "上報正文",
  "priceChannel.readingSubmissions": "正在讀取上報記錄…",
  "priceChannel.noSubmissions": "暫無上報記錄。",
  "priceChannel.publicationRequest": "發佈申請 {id}",
  "priceChannel.awaitRelease": "等待公開版本",
  "priceChannel.viewStatus": "查看狀態",
  "priceChannel.submitForReview": "送審",
  "priceChannel.confirmReview":
    "確認將當前不可變修訂送運營審核？儲存後不能原位改寫。",
  "priceChannel.confirmSubmit": "確認送審",
  "priceChannel.cancel": "取消",
  "priceChannel.businessStatus": "業務狀態",
  "priceChannel.version": "版本",
  "priceChannel.revision": "修訂引用",
  "priceChannel.releaseVersion": "發佈版本",
  "priceChannel.notActivated": "尚未激活",
  "priceChannel.publicationStage": "發佈階段",
  "priceChannel.publicationReceiptTimeline": "發佈回執時間線",
  "priceChannel.publicationTimelineUnavailable":
    "當前詳情未提供完整的發佈回執字段，請確認後端版本；不以當前狀態推斷歷史。",
  "priceChannel.publicationReceiptTimeHint":
    "以下按商城收到回執的時間排列，並非業務發生時間；回執順序不代表當前狀態回退。",
  "priceChannel.publicationTimelineTruncated":
    "僅展示最近200條回執，更早記錄未在此頁載入。",
  "priceChannel.noPublicationReceipt": "尚無發佈回執記錄。",
  "priceChannel.publicationReceiptStage.FACT_ACCEPTED": "事實接收",
  "priceChannel.publicationReceiptStage.MARKET_RELEASE_ACTIVATED":
    "公開版本激活",
  "priceChannel.publicationFactPending": "事實入庫待確認，尚未公開",
  "priceChannel.publicationCalculating": "事實已接受，等待指數與公開版本",
  "priceChannel.publicationActivated": "公開版本 {version} 已激活",
  "priceChannel.submissionPayloadUnavailable":
    "當前詳情缺少經後端修訂校驗的正文，無法核對原上報字段。",
  "priceChannel.submissionTimelineUnavailable":
    "後端詳情尚未返回完整審核時間線，不能用當前狀態推斷歷史節點。",
  "priceChannel.returnRecoveryUnavailable":
    "退回後恢復編輯需讀取原修訂正文；當前詳情不完整，暫不可安全恢復。",
  "priceChannel.submissionReadFailed": "上報記錄讀取失敗",
  "priceChannel.subjectRequired": "請選擇獲授權的上報主體",
  "priceChannel.draftSaved": "草稿 {id} 已儲存，可在下方明確送審。",
  "priceChannel.draftSaveFailed": "草稿儲存失敗，可重試原請求",
  "priceChannel.draftChanged": "草稿已變化，請刷新後重試",
  "priceChannel.submitted": "已送交運營審核。",
  "priceChannel.submitFailed": "送審失敗",
  "priceChannel.detailReadFailed": "上報詳情讀取失敗",
  "priceChannel.reviewHint":
    "僅展示當前 Spring 身份和主體範圍內的待辦；每次審核會重新讀取版本，最終由服務端校驗。",
  "priceChannel.readingReviews": "正在讀取審核隊列…",
  "priceChannel.noReviews": "當前沒有待審事項。",
  "priceChannel.operationsReview": "運營審核",
  "priceChannel.viewDetail": "查看詳情",
  "priceChannel.approve": "通過",
  "priceChannel.return": "退回",
  "priceChannel.reject": "拒絕",
  "priceChannel.currentVersion": "當前版本 {version}",
  "priceChannel.typeRevision": "類型 {type} · 修訂 {revision}",
  "priceChannel.evidenceCount": "證明材料 {count} 份",
  "priceChannel.reviewPayloadUnavailable":
    "當前詳情缺少經後端修訂校驗的上報正文與審核記錄，不能在未核對內容時審核。",
  "priceChannel.reviewContentChanged": "待審內容已變化，請重新查看後再決定",
  "priceChannel.confirmDecision": "確認{decision}？",
  "priceChannel.reviewOpinion": "審核意見（1–25 字）",
  "priceChannel.processing": "處理中…",
  "priceChannel.confirmAction": "確認提交",
  "priceChannel.certificationTitle": "企業認證 · {id}",
  "priceChannel.reviewReadFailed": "待辦讀取失敗",
  "priceChannel.reviewDetailReadFailed": "審核詳情讀取失敗",
  "priceChannel.reviewDone":
    "審核已{decision}；公開行情仍須等待發布與 Release 激活。",
  "priceChannel.reviewFailed": "審核失敗，請刷新後重試",
  "priceChannel.closeApplication": "收起申請",
  "priceChannel.startCertification": "發起認證",
  "priceChannel.noEnterpriseSubject":
    "當前身份沒有獲授權的企業主體，無法發起認證。",
  "priceChannel.certificationSubject": "認證主體",
  "priceChannel.certificationType": "認證類型",
  "priceChannel.evidenceMaterials": "證明材料",
  "priceChannel.evidencePickerHint":
    "從當前賬號的可見檔案庫選擇，最多 {max} 份；不會提交路徑或 URL。",
  "priceChannel.removeEvidence": "移除證明檔案 {name}",
  "priceChannel.readingFiles": "讀取中…",
  "priceChannel.refreshFiles": "刷新檔案庫",
  "priceChannel.fileLibraryHint":
    "僅引用當前賬號檔案庫中已完成的檔案；不上傳路徑或 URL。最多 20 份。",
  "priceChannel.noFiles": "檔案庫暫無可選文檔，請先在個人檔案庫上傳。",
  "priceChannel.fileNumber": "檔案 {id}",
  "priceChannel.submitting": "提交中…",
  "priceChannel.submitCertification": "提交認證申請",
  "priceChannel.readingCertifications": "正在讀取認證記錄…",
  "priceChannel.noCertifications": "暫無認證申請。",
  "priceChannel.applicationNumber": "申請號 {id}",
  "priceChannel.viewReviewHistory": "查看審核記錄",
  "priceChannel.currentStage": "當前階段：{stage}",
  "priceChannel.awaitProcessing": "待處理",
  "priceChannel.noReviewEvent": "尚無審核事件。",
  "priceChannel.noOpinion": "未填寫意見",
  "priceChannel.certificationReadFailed": "認證記錄讀取失敗",
  "priceChannel.filesReadFailed": "檔案庫讀取失敗",
  "priceChannel.certificationRequired":
    "請選擇獲授權主體、認證類型和 1–20 份證明材料",
  "priceChannel.certificationSaved": "認證申請已儲存到業務系統。",
  "priceChannel.certificationFailed": "認證申請失敗",
  "priceChannel.reviewHistoryReadFailed": "審核記錄讀取失敗",
  "priceChannel.reviewResults": "審查結果",
  "priceChannel.noReviewResult": "當前類型暫無已審記錄。",
  "priceChannel.resultListIncomplete": "審查結果列表數據不完整，請稍後重試。",
  "priceChannel.resultLinkInvalid":
    "審查結果鏈接的類型或業務 ID 無效；舊演示編號尚未建立正式映射。",
  "priceChannel.resultDetailIncomplete":
    "審查詳情缺少原始內容或審核時間線，無法安全展示。",
  "priceChannel.reviewResultsDescription":
    "集中查看企業認證、產品上報與料號上報的已完成審查結果。",
  "priceChannel.reviewResultTypes": "審查結果類型",
  "priceChannel.reviewResultsFor": "{type}審查結果",
  "priceChannel.noReviewResultsFor": "{type}暫無已完成審查結果",
  "priceChannel.closeDetail": "收起詳情",
  "priceChannel.statusTimeline": "狀態軌跡",
  "priceChannel.resultGroup.certification": "企業認證",
  "priceChannel.resultGroup.product": "產品上報",
  "priceChannel.resultGroup.part-number": "料號上報",
  "priceChannel.backToCategory": "返回{name}",
  "priceChannel.profileSections": "行情檔案章節",
  "priceChannel.sectionNav.market": "趨勢",
  "priceChannel.sectionNav.spec": "料號",
  "priceChannel.sectionNav.comparison": "行情",
  "priceChannel.sectionNav.overview": "概覽",
  "priceChannel.sectionNav.events": "事件",
  "priceChannel.sectionNav.research": "研究",
  "priceChannel.sectionNav.sources": "來源",
  "priceChannel.compositeTrend": "綜合趨勢與來源觀測",
  "priceChannel.timeRange": "行情時間範圍",
  "priceChannel.inventoryTitle": "料號與庫存批組",
  "priceChannel.partBackground": "料號與規格背景",
  "priceChannel.noPublishedParts": "暫無已發佈料號",
  "priceChannel.publishedPartsHint":
    "產品檔案已發佈；料號、庫存批組與報價通過審核後將在此自動補齊。",
  "priceChannel.objectLevel": "對象層級",
  "priceChannel.objectLevelHint":
    "當前對象用於聚合同一標準規格，具體料號以公開展示內容為準。",
  "priceChannel.trendBoundary": "趨勢輸入邊界",
  "priceChannel.trendBoundaryHint":
    "只有規格、來源和時間口徑一致的樣本才進入趨勢計算。",
  "priceChannel.specificParts": "具體料號",
  "priceChannel.partLoadRetry": "料號載入失敗，點擊重試",
  "priceChannel.partPreparing": "正在準備料號資料…",
  "priceChannel.marketRelated": "行情相關",
  "priceChannel.industryRelated": "行業相關",
  "priceChannel.relatedLoadRetry": "行情載入失敗，點擊重試",
  "priceChannel.relatedPreparing": "正在準備相關行情…",
  "priceChannel.noRelatedMarkets": "暫無可關聯行情",
  "priceChannel.relatedHint":
    "當前產品事實已公開，待同規格產品或上位行情形成後自動建立關聯。",
  "priceChannel.productOverview": "產品與規格概覽",
  "priceChannel.productIndex": "產品指數",
  "priceChannel.brandProfile": "{brand}品牌檔案",
  "priceChannel.brand": "品牌",
  "priceChannel.productKind": "產品總類 / 細分",
  "priceChannel.standardSpecification": "標準規格",
  "priceChannel.representativePart": "代表料號",
  "priceChannel.trendBasis": "趨勢口徑",
  "priceChannel.application": "應用",
  "priceChannel.latestIndex": "最新指數",
  "priceChannel.sevenDayChange": "近7日變化",
  "priceChannel.dailyChange": "日漲跌幅",
  "priceChannel.sevenDayBasis": "當前指數相對7D區間昨收",
  "priceChannel.totalSamples": "累計樣本",
  "priceChannel.anonymizedSources": "{count}類脱敏來源口徑",
  "priceChannel.marketEvents": "行情事件",
  "priceChannel.research": "研究與公告",
  "priceChannel.researchItem.0.title": "行情摘要",
  "priceChannel.researchItem.0.detail":
    "近30日固定序列、樣本覆蓋和同類標的差異的本地摘要。",
  "priceChannel.researchItem.1.title": "規格摘要",
  "priceChannel.researchItem.1.detail":
    "集中展示代表料號、封裝、速率或良率等公開規格資料。",
  "priceChannel.researchItem.2.title": "來源公告位",
  "priceChannel.researchItem.2.detail":
    "正式上線後用於展示授權來源公告與公開引用。",
  "priceChannel.sourceCoverage": "來源覆蓋",
  "priceChannel.sourceLoadRetry": "來源載入失敗，點擊重試",
  "priceChannel.sourcePreparing": "正在準備來源覆蓋…",
  "priceChannel.profileCompanyMark": "產品檔案公司標識",
  "priceChannel.profileEnd": "PRICE INDEX · 檔案末尾",
  "priceChannel.profileEndHint": "可信數據鏈路 · DEMO 檔案瀏覽結束",
  "priceChannel.detailLoading": "正在載入行情詳情",
  "priceChannel.temporaryCard": "瀏覽器臨時趨勢卡片 {id}",
  "priceChannel.temporaryHint":
    "該卡片僅用於本地Demo演示，不代表正式發佈行情。",
  "priceChannel.cardSpecification": "卡片與標準規格",
  "priceChannel.trendSummary": "趨勢摘要",
  "priceChannel.trendSummaryHint": "展示本地演示數據的公開行情字段。",
  "priceChannel.instrumentNotFound": "未找到該行情標的",
  "priceChannel.instrumentNotFoundHint":
    "標的ID無效，或當前Demo數據中不存在該對象。",
  "priceChannel.trendNoPublishedSamples":
    "產品檔案已發佈，暫無可計算的趨勢樣本",
  "priceChannel.trendNoData": "當前趨勢暫無可展示數據",
  "priceChannel.chartUnit": "趨勢指數（基期=100）",
  "priceChannel.spec.technology": "產品類型",
  "priceChannel.spec.density": "單顆容量",
  "priceChannel.spec.dataWidth": "位寬",
  "priceChannel.spec.organization": "組織",
  "priceChannel.spec.die": "Die",
  "priceChannel.spec.speed": "等級",
  "priceChannel.spec.timing": "標稱時序",
  "priceChannel.spec.package": "封裝",
  "priceChannel.spec.dieStack": "Die Stack",
  "priceChannel.spec.voltage": "工作電壓",
  "priceChannel.spec.temperature": "工作温度",
  "priceChannel.temporarySpec.cardTitle": "卡片標題",
  "priceChannel.temporarySpec.cardSpec": "卡片規格",
  "priceChannel.temporarySpec.fullPart": "完整料號",
  "priceChannel.temporarySpec.application": "應用場景",
  "priceChannel.temporarySpec.lifecycle": "生命週期",
  "priceChannel.temporarySpec.validUntil": "數據有效期",
  "priceChannel.notProvided": "未提供",
  "priceChannel.sidebar.publicProductCategories": "公開行情產品分類",
  "priceChannel.sidebar.searchBrand": "搜索品牌",
  "priceChannel.sidebar.brandInitials": "{name}首字母篩選",
  "priceChannel.sidebar.noBrands": "暫無匹配品牌",
  "priceChannel.sidebar.searchTechnicalFamily": "搜索分類技術族",
  "priceChannel.sidebar.publicCategories": "公開行情兩級分類",
  "priceChannel.sidebar.subcategories": "{name}細分類",
  "priceChannel.sidebar.noTechnicalFamilies": "暫無匹配技術族",
  "priceChannel.operations.title": "產品與料號人工審核",
  "priceChannel.operations.pendingCount": "{count} 項待處理",
  "priceChannel.operations.filter": "運營審核對象篩選",
  "priceChannel.operations.tab.ALL": "全部",
  "priceChannel.operations.tab.PRODUCT_FACT": "產品事實",
  "priceChannel.operations.tab.PART_NUMBER": "標準料號",
  "priceChannel.operations.tab.INVENTORY_BATCH": "庫存批組",
  "priceChannel.operations.tab.QUOTE_OBSERVATION": "報價觀察",
  "priceChannel.operations.tab.ENGINEERING_RETURN": "工程退回",
  "priceChannel.operations.publicProfile": "公開產品檔案補充",
  "priceChannel.operations.completeProfile": "補齊分類詳情頁必需資料",
  "priceChannel.operations.autofill": "一鍵補充",
  "priceChannel.operations.profileBoundary":
    "這裏不填寫料號、庫存和報價；它們由後續“料號上報”獨立維護。",
  "priceChannel.operations.brandDisplayName": "品牌展示名稱",
  "priceChannel.operations.subcategory": "產品細分",
  "priceChannel.operations.lifecycle": "生命週期",
  "priceChannel.operations.summary": "產品説明",
  "priceChannel.operations.saveProfile": "儲存補充資料",
  "priceChannel.operations.saveBeforeApprove":
    "全部必填資料儲存後，才允許“通過”並進入公開分類。",
  "priceChannel.operations.opinionPlaceholder":
    "通過、退回或拒絕都必須説明理由",
  "priceChannel.operations.startReview": "開始審核",
  "priceChannel.operations.requestChanges": "退回補充",
  "priceChannel.operations.noMatching": "當前篩選範圍沒有待審核對象",
  "priceChannel.operations.productFolder": "產品資料夾",
  "priceChannel.operations.partIntake": "料號進件",
  "priceChannel.operations.reviewStarted": "已開始審核產品資料",
  "priceChannel.operations.autofillReady":
    "已生成一組公開產品檔案Demo資料，再次點擊可切換",
  "priceChannel.operations.profileSaved": "公開產品檔案已儲存",
  "priceChannel.operations.profileForbidden":
    "當前身份不能補充該產品的公開檔案",
  "priceChannel.operations.profileIncomplete": "公開產品檔案尚未補齊",
  "priceChannel.operations.opinionRequired": "請先填寫審核意見",
  "priceChannel.operations.opinionTooLong": "審核意見最多輸入25個字符",
  "priceChannel.operations.notPublishable": "當前記錄尚未滿足發佈條件",
  "priceChannel.operations.reviewUnavailable": "當前記錄無法審核",
  "priceChannel.operations.approved": "運營審核通過，Demo 數據已發佈",
  "priceChannel.operations.saved": "運營審核結果已儲存",
  "priceChannel.catalog.draftChanged": "產品草稿狀態已變化，請刷新後重試",
  "priceChannel.messages.visibleSubmissions": "{count} 項可見申報",
  "priceChannel.messages.ready": "可立即處理",
  "priceChannel.messages.workflow.certification-review.title": "待審核企業認證",
  "priceChannel.messages.workflow.certification-review.detail":
    "品牌方和平台商提交後統一進入運營部審核",
  "priceChannel.messages.workflow.operations-review.title": "待處理運營審核",
  "priceChannel.messages.workflow.operations-review.detail":
    "產品事實與料號、庫存批組、報價統一在同一工作區審核",
  "priceChannel.messages.workflow.part-number-submit.title": "料號上報",
  "priceChannel.messages.workflow.part-number-submit.detail":
    "在已有或新建產品下新增料號、跟進庫存批組與報價",
  "priceChannel.messages.workflow.product-submit.title": "產品上報",
  "priceChannel.messages.workflow.product-submit.detail":
    "只建立產品基礎檔案，不夾帶料號、庫存或報價",
  "priceChannel.quote.folderHint": "產品資料夾下的料號、庫存與報價",
  "priceChannel.quote.headingStatus": "業務提交 · 運營審核後發佈",
  "priceChannel.quote.combineObject": "組合報價對象",
  "priceChannel.quote.chooseProduct": "選擇產品",
  "priceChannel.quote.channel": "報價渠道",
  "priceChannel.quote.chooseSource": "選擇報價來源",
  "priceChannel.quote.partMode": "料號操作方式",
  "priceChannel.quote.followPart": "跟進料號",
  "priceChannel.quote.newPart": "新增料號",
  "priceChannel.quote.chooseExistingPart": "選擇現有料號",
  "priceChannel.quote.newPartHint": "生成進件時自動創建不衝突的新料號",
  "priceChannel.quote.batchMode": "庫存批次操作方式",
  "priceChannel.quote.followBatch": "跟進批次",
  "priceChannel.quote.newBatch": "新增批次",
  "priceChannel.quote.chooseExistingBatch": "選擇現有批次",
  "priceChannel.quote.newBatchHint": "生成進件時創建新的庫存批次",
  "priceChannel.quote.regenerate": "換一組報價資料",
  "priceChannel.quote.generate": "生成本次報價進件",
  "priceChannel.quote.currentCombination": "當前組合",
  "priceChannel.quote.channelShort": "渠道",
  "priceChannel.quote.batchShort": "批次",
  "priceChannel.quote.batchHistory": "批次報價歷史",
  "priceChannel.quote.noPublishedQuotes": "當前庫存批次還沒有已發佈報價",
  "priceChannel.quote.intakeAndAi": "本次進件與 AI 預解析",
  "priceChannel.quote.rawIntake": "原始報價進件",
  "priceChannel.quote.time": "報價時間",
  "priceChannel.quote.stockMoq": "庫存 / MOQ",
  "priceChannel.quote.tierPrices": "階梯價",
  "priceChannel.quote.tiers": "{count} 檔",
  "priceChannel.quote.aiPreparse": "AI 預解析",
  "priceChannel.quote.demoCandidate": "演示候選",
  "priceChannel.quote.correctedValue": "{name}修正值",
  "priceChannel.quote.regenerateCandidate": "{name}重新生成候選值",
  "priceChannel.quote.currentDecision": "{name}當前狀態為{status}",
  "priceChannel.quote.cycleDecision": "{name}切換確認、修正或重置",
  "priceChannel.quote.stableMapping": "穩定映射",
  "priceChannel.quote.confirmUpload": "確認上傳並交付運營部",
  "priceChannel.quote.notGenerated": "尚未生成本次進件",
  "priceChannel.quote.generateHint":
    "先在左側確定組合，再生成報價與 AI 預解析結果。",
  "priceChannel.quote.decision.ACCEPTED": "確認",
  "priceChannel.quote.decision.CORRECTED": "修正",
  "priceChannel.quote.decision.REGENERATED": "重置",
  "priceChannel.quote.notSelected": "尚未選擇",
  "priceChannel.quote.autoGenerate": "將自動生成",
  "priceChannel.quote.withNewBatch": "隨新批次生成",
  "priceChannel.quote.generated": "已按當前組合生成本次報價和 AI 預解析結果",
  "priceChannel.quote.correctedRequired": "{name}修正值不能為空",
  "priceChannel.quote.timePending": "時間待補充",
  "priceChannel.quote.quantityUnknown": "數量未知",
  "priceChannel.quote.confirmFields": "請完成AI字段確認",
  "priceChannel.quote.sourceForbidden": "當前身份無權提交該渠道來源",
  "priceChannel.quote.submitted": "上傳確認快照已儲存，已進入運營審核隊列",
  "priceChannel.brandArchive": "品牌檔案",
  "priceChannel.brandCounts": "{categories} 個經營分類 · {products} 個相關產品",
  "priceChannel.regionalMarketCaveat":
    "按當前報價來源歸屬重算，不代表當地成交價格；各分類獨立統計。",
  "priceChannel.marketObservation": "市場觀察",
  "priceChannel.brandMarketLevel": "{level}級品牌行情",
  "priceChannel.productRelated": "產品相關",
  "priceChannel.openMarketArchive": "查看{name}行情檔案",
  "priceChannel.sevenDayCompositeSparkline": "{name}近7日綜合趨勢縮略圖",
  "priceChannel.sevenDayMarketSparkline": "{name}近7日行情趨勢縮略圖",
  "priceChannel.defaultMarketSparkline": "近7日行情趨勢縮略圖",
  "priceChannel.demo": "演示",
  "priceChannel.approvedProductCount": "{count} 個已審核產品",
  "priceChannel.coverageCounts": "{categories} 個分類 · {products} 個產品",
  "priceChannel.related.parent": "上位相關",
  "priceChannel.related.peer": "同級相關",
  "priceChannel.related.child": "下位相關",
  "priceChannel.related.peerAndParent": "同級與上位相關",
  "priceChannel.spotBoard.title": "當前產品總類行情標的大盤",
  "priceChannel.spotBoard.favorite": "收藏",
  "priceChannel.spotBoard.model": "產品型號",
  "priceChannel.spotBoard.index": "指數",
  "priceChannel.spotBoard.sevenDay": "近7日",
  "priceChannel.spotBoard.recentRange": "近7點指數高 / 低",
  "priceChannel.spotBoard.samplesSources": "樣本 / 來源",
  "priceChannel.spotBoard.trend": "走勢圖",
  "priceChannel.spotBoard.sourceSummary":
    "{samples}個樣本，{sources}個來源，{detail}",
  "priceChannel.personal.readOnly": "當前為只讀模式",
  "priceChannel.personal.viewCertification": "查看認證",
  "priceChannel.personal.timelineLabel": "提交審核發佈時間線，最新節點在左側",
  "priceChannel.personal.noTimelineEvents": "暫無已記錄的提交事件",
  "priceChannel.personal.noEventTime": "未記錄時間",
  "priceChannel.personal.messageDescription":
    "行情更新、料號庫存、業務事項與系統通知均按當前模擬賬號獨立彙總。",
  "priceChannel.personal.filter.ALL": "全部",
  "priceChannel.personal.filter.UNREAD": "未讀",
  "priceChannel.personal.messageCategories": "訊息分類",
  "priceChannel.personal.category.ALL": "全部",
  "priceChannel.personal.category.MARKET": "行情關注",
  "priceChannel.personal.category.INVENTORY": "料號 / 庫存",
  "priceChannel.personal.category.WORKFLOW": "業務流程",
  "priceChannel.personal.category.SYSTEM": "系統",
  "priceChannel.personal.businessItems": "業務事項",
  "priceChannel.personal.openRelated": "打開關聯對象",
  "priceChannel.personal.markRead": "標記已讀",
  "priceChannel.personal.noMessages": "暫無符合條件的訊息",
  "priceChannel.personal.submissionHistory": "提交歷史",
  "priceChannel.personal.coreSpecs": "核心規格",
  "priceChannel.personal.collapseDetails": "收起詳細資料",
  "priceChannel.personal.expandDetails": "展開詳細資料",
  "priceChannel.personal.initialDraftTime": "初稿時間：{time}",
  "priceChannel.personal.formalSubmit": "正式提交",
  "priceChannel.personal.noVisibleSubmissions": "暫無可見申報",
  "priceChannel.personal.submissionHint":
    "提交產品或料號資料後，運營審核狀態會顯示在這裏。",
  "priceChannel.personal.productBasicProfile": "產品基礎檔案",
  "priceChannel.personal.moreSpecs": "{values} 等",
  "priceChannel.personal.productReadOnly":
    "當前身份或企業認證不允許創建產品申報。",
  "priceChannel.personal.autofillV5": "一鍵填報第五版示例",
  "priceChannel.personal.productDisplayName": "產品展示名稱",
  "priceChannel.personal.stableBrand": "穩定品牌",
  "priceChannel.personal.technicalDimensions": "技術維度",
  "priceChannel.personal.v5Dimensions": "第五版產品維度",
  "priceChannel.personal.reset": "重置",
  "priceChannel.personal.submitToOperations": "正式提交運營審核",
  "priceChannel.personal.nameRequired": "請輸入產品展示名稱",
  "priceChannel.personal.categoryRequired": "請選擇一級分類",
  "priceChannel.personal.brandRequired": "請選擇穩定品牌",
  "priceChannel.personal.dimensionRequired": "請選擇{name}",
  "priceChannel.statusTag.UNVERIFIED": "未認證",
  "priceChannel.statusTag.DRAFT": "草稿",
  "priceChannel.statusTag.SUBMITTED": "已提交",
  "priceChannel.statusTag.UNDER_REVIEW": "審核中",
  "priceChannel.statusTag.DEPARTMENT_APPROVED": "待領導終審",
  "priceChannel.statusTag.CHANGES_REQUESTED": "退回補充",
  "priceChannel.statusTag.REJECTED": "未通過",
  "priceChannel.statusTag.APPROVED": "已通過",
  "priceChannel.statusTag.PUBLISHED": "已發佈",
  "priceChannel.statusTag.EXPIRED": "已過期",
  "priceChannel.statusTag.REVOKED": "已撤銷",
  "priceChannel.profile.title": "企業資料",
  "priceChannel.profile.hint": "展示企業主體、經營能力和聯絡人。",
  "priceChannel.profile.preview": "預覽公開檔案",
  "priceChannel.profile.summary": "企業檔案摘要",
  "priceChannel.profile.completeness": "資料完整度",
  "priceChannel.profile.completenessHint": "按必填分組計算",
  "priceChannel.profile.status": "檔案狀態",
  "priceChannel.profile.statusHint": "狀態不由儲存動作提升",
  "priceChannel.profile.approvedQualifications": "有效資質",
  "priceChannel.profile.qualificationHint": "完整版本進入資料庫",
  "priceChannel.profile.organization": "企業主體",
  "priceChannel.profile.displayName": "企業展示名",
  "priceChannel.profile.shortName": "企業簡稱",
  "priceChannel.profile.region": "所屬地區",
  "priceChannel.profile.supplierCode": "供應商Demo編碼",
  "priceChannel.profile.organizationId": "組織ID",
  "priceChannel.profile.parentOrganization": "主/子組織關係",
  "priceChannel.profile.description": "企業簡介",
  "priceChannel.profile.capabilities": "經營能力",
  "priceChannel.profile.productFamilies": "產品族",
  "priceChannel.profile.brandManufacturers": "品牌/原廠",
  "priceChannel.profile.applications": "應用領域",
  "priceChannel.profile.supplyRegions": "供貨地區",
  "priceChannel.profile.commonMoq": "常見MOQ",
  "priceChannel.profile.leadTime": "常見交期",
  "priceChannel.profile.stockConditions": "貨況口徑",
  "priceChannel.profile.contacts": "聯絡方式",
  "priceChannel.profile.defaultContact": "預設",
  "priceChannel.profile.materialSummary": "認證材料摘要",
  "priceChannel.profile.openLibrary": "打開資料庫",
  "priceChannel.profile.savedLocally": "當前頁面草稿已儲存，未寫入後端。",
  "priceChannel.profile.saveDraft": "儲存本地草稿",
  "priceChannel.profile.readOnly": "當前身份只讀",
  "priceChannel.profile.noOrganization": "當前身份沒有可用的企業組織範圍",
  "priceChannel.profile.publicPreview": "企業公開檔案預覽",
  "priceChannel.profile.publicPreviewHint":
    "只顯示已批准、已發佈且明確公開的字段。",
  "priceChannel.profile.backToProfile": "返回企業資料",
  "priceChannel.profile.publicProfile": "公開企業檔案",
  "priceChannel.profile.brands": "覆蓋品牌",
  "priceChannel.profile.notPublic": "檔案尚未批准並公開",
  "priceChannel.qualification.title": "資質資料",
  "priceChannel.qualification.hint":
    "附件僅儲存脱敏元數據；版本替換不會覆蓋歷史記錄。",
  "priceChannel.qualification.type": "資料類型",
  "priceChannel.qualification.allTypes": "全部類型",
  "priceChannel.qualification.reviewStatus": "審核狀態",
  "priceChannel.qualification.allStatuses": "全部狀態",
  "priceChannel.qualification.versions": "資料版本",
  "priceChannel.qualification.count": "{count} 條",
  "priceChannel.qualification.effectivePeriod": "有效期",
  "priceChannel.qualification.selectedAt": "選擇時間",
  "priceChannel.qualification.linkedProducts": "關聯產品",
  "priceChannel.qualification.noLinkedProducts": "未關聯產品",
  "priceChannel.qualification.replacedVersion": "替換版本",
  "priceChannel.qualification.firstVersion": "首個版本",
  "priceChannel.qualification.latestReturn": "最近退回：",
  "priceChannel.qualification.empty": "當前篩選條件下沒有資質資料",
  "priceChannel.qualification.createVersion": "創建新版本草稿",
  "priceChannel.qualification.selectAttachment": "選擇演示附件",
  "priceChannel.qualification.noExtension": "無擴展名",
  "priceChannel.qualification.noFile": "尚未選擇檔案；不會讀取附件內容。",
  "priceChannel.qualification.readOnly": "當前身份只讀，不能創建資料版本。",
  "priceChannel.qualification.saveDraft": "儲存為新版本草稿",
  "priceChannel.qualification.saved": "資質新版本已創建為共享草稿。",
  "priceChannel.certCenter.title": "企業認證",
  "priceChannel.certCenter.hint":
    "企業主體、品牌或授權範圍審核採用部門審核與領導終審兩階段。",
  "priceChannel.certCenter.resetDemo": "重置認證Demo",
  "priceChannel.certCenter.leaderReview": "企業認證進度與終審",
  "priceChannel.certCenter.departmentReview": "企業認證部門審核",
  "priceChannel.certCenter.noReview": "當前沒有待審核企業認證。",
  "priceChannel.certCenter.currentSubject": "當前認證主體",
  "priceChannel.certCenter.legalName": "企業法定名稱",
  "priceChannel.certCenter.creditCode": "統一社會信用代碼",
  "priceChannel.certCenter.contact": "聯絡人",
  "priceChannel.certCenter.validUntil": "有效期",
  "priceChannel.certCenter.scope": "認證範圍",
  "priceChannel.certCenter.applicationProgress": "認證申請進度",
  "priceChannel.certCenter.applicationMaterials": "本次申請資料",
  "priceChannel.certCenter.noCertification": "當前組織尚未建立企業認證資料",
  "priceChannel.certCenter.start": "開始認證",
  "priceChannel.certCenter.notApplicable": "當前身份不適用企業認證",
  "priceChannel.certCenter.roleHint":
    "{role}使用內部組織授權或公開只讀範圍，不創建外部企業認證。企業認證僅面向自有品牌和授權平台商。",
  "priceChannel.certCenter.demoDisclaimer":
    "本頁全部企業、材料、狀態、審核和有效期均為瀏覽器本地Demo，不構成真實企業認證、授權或資質背書。",
  "priceChannel.certCenter.registeredAddress": "註冊地址",
  "priceChannel.certCenter.website": "企業官網",
  "priceChannel.certCenter.notProvided": "未填寫",
  "priceChannel.certCenter.contactPhone": "聯繫電話",
  "priceChannel.certCenter.contactEmail": "聯繫電郵地址",
  "priceChannel.certCenter.evidence": "證明材料",
  "priceChannel.certCenter.productCategories": "產品類別",
  "priceChannel.certCenter.brands": "品牌",
  "priceChannel.certCenter.businessRegions": "業務區域",
  "priceChannel.certCenter.priceTypes": "價格類型",
  "priceChannel.certCenter.businessDescription": "業務與數據來源説明",
  "priceChannel.certMaterials.subject": "企業主體",
  "priceChannel.certMaterials.type": "企業類型",
  "priceChannel.certMaterials.type.SELF_OWNED_BRAND": "自有品牌",
  "priceChannel.certMaterials.type.AUTHORIZED_PLATFORM": "授權平台商",
  "priceChannel.certMaterials.organizationId": "組織ID",
  "priceChannel.certMaterials.contactSection": "聯絡人與業務説明",
  "priceChannel.certMaterials.businessDescription": "業務説明",
  "priceChannel.certMaterials.scope": "申報業務範圍",
  "priceChannel.certMaterials.evidenceCount": "證明材料（{count} 份）",
  "priceChannel.certMaterials.evidenceType": "材料類型：",
  "priceChannel.certMaterials.evidenceId": "Evidence ID：",
  "priceChannel.certMaterials.demoDigest": "Demo摘要：",
  "priceChannel.certMaterials.noEvidence": "未提交證明材料。",
  "priceChannel.certMaterials.reviewTrace": "提交與審核軌跡",
  "priceChannel.certMaterials.certificationId": "認證編號",
  "priceChannel.certMaterials.source": "數據來源",
  "priceChannel.certMaterials.submittedAt": "提交時間",
  "priceChannel.certMaterials.updatedAt": "最近更新",
  "priceChannel.certMaterials.departmentReview": "運營部審核",
  "priceChannel.certMaterials.departmentOpinion": "運營部意見",
  "priceChannel.certMaterials.leaderReview": "領導終審",
  "priceChannel.certMaterials.leaderOpinion": "領導意見",
  "priceChannel.certMaterials.validFrom": "認證生效",
  "priceChannel.certMaterials.notFilled": "未填寫",
  "priceChannel.certMaterials.notOccurred": "尚未發生",
  "priceChannel.certMaterials.listSeparator": "、",
  "priceChannel.certMaterials.fixture": "凍結Fixture",
  "priceChannel.certMaterials.browserJson": "瀏覽器臨時JSON",
  "priceChannel.certMaterials.evidence.BUSINESS_LICENSE": "營業執照",
  "priceChannel.certMaterials.evidence.BRAND_OWNERSHIP": "品牌權屬材料",
  "priceChannel.certMaterials.evidence.CHANNEL_AUTHORIZATION": "渠道授權材料",
  "priceChannel.certMaterials.evidence.OTHER": "其他證明材料",
  "priceChannel.certMaterials.evidenceStatus.PENDING": "待校驗",
  "priceChannel.certMaterials.evidenceStatus.NEEDS_REVIEW": "待人工複核",
  "priceChannel.certMaterials.evidenceStatus.ACCEPTED": "已接受",
  "priceChannel.certMaterials.evidenceStatus.REJECTED": "已拒絕",
  "priceChannel.certMaterials.status.UNVERIFIED": "演示未認證",
  "priceChannel.certMaterials.status.DRAFT": "資料待提交",
  "priceChannel.certMaterials.status.SUBMITTED": "已提交",
  "priceChannel.certMaterials.status.UNDER_REVIEW": "部門審核中",
  "priceChannel.certMaterials.status.DEPARTMENT_APPROVED": "部門已通過",
  "priceChannel.certMaterials.status.CHANGES_REQUESTED": "待補資料",
  "priceChannel.certMaterials.status.APPROVED": "演示已認證",
  "priceChannel.certMaterials.status.REJECTED": "演示未通過",
  "priceChannel.certMaterials.status.SUSPENDED": "演示已停用",
  "priceChannel.certMaterials.status.EXPIRED": "演示已過期",
  "priceChannel.certTimeline.aria": "認證審核執行流程",
  "priceChannel.certTimeline.opinion": "審核意見：{opinion}",
  "priceChannel.certTimeline.stage.submitter": "申請方提交",
  "priceChannel.certTimeline.stage.operations": "運營部審核",
  "priceChannel.certTimeline.stage.leader": "領導終審",
  "priceChannel.certTimeline.stageExtra": "審核階段{number}",
  "priceChannel.submissionDetail.title": "提交詳情",
  "priceChannel.submissionDetail.unknown": "未知提交",
  "priceChannel.submissionDetail.back": "返回申報進度",
  "priceChannel.submissionDetail.version": "版本 {version}",
  "priceChannel.submissionDetail.productName": "產品名稱",
  "priceChannel.submissionDetail.fullPartNumber": "完整料號",
  "priceChannel.submissionDetail.normalizedPartNumber": "規範料號",
  "priceChannel.submissionDetail.dimensions": "第五版維度",
  "priceChannel.submissionDetail.reviewTimeline": "審核時間線",
  "priceChannel.submissionDetail.notFound": "提交不存在或超出當前對象範圍",
  "priceChannel.eventTimeline.empty": "暫無狀態事件",
  "priceChannel.rangeMore.more": "更多",
  "priceChannel.rangeMore.aria": "自定義行情指數範圍",
  "priceChannel.rangeMore.timezone": "時間按北京時間（UTC+8）填寫",
  "priceChannel.rangeMore.invalid": "時間範圍無效或超出當前發佈版本的範圍",
  "priceChannel.legacySurface.company": "本企業資料",
  "priceChannel.legacySurface.qualifications": "認證材料",
  "priceChannel.legacySurface.company-preview": "企業公開檔案",
  "priceChannel.legacySurface.unavailable":
    "此入口已保留，但正式企業資料、資質庫與公開檔案介面尚未接通；這裏不會顯示演示數據。",
  "priceChannel.legacySurface.certifications": "查看已接通的企業認證",
  "priceChannel.rangeMore.start": "開始時間",
  "priceChannel.rangeMore.end": "結束時間",
  "priceChannel.rangeMore.granularity": "粒度",
  "priceChannel.rangeMore.minute": "分鐘",
  "priceChannel.rangeMore.hour": "小時",
  "priceChannel.rangeMore.day": "日",
  "priceChannel.rangeMore.week": "周",
  "priceChannel.rangeMore.month": "月",
  "priceChannel.rangeMore.step": "間隔",
  "priceChannel.rangeMore.hint": "分鐘級僅用於Demo採樣，最多展示90個點。",
  "priceChannel.rangeMore.apply": "應用範圍",
  "priceChannel.record.quoteObject": "組合報價對象",
  "priceChannel.record.quoteChannel": "報價渠道",
  "priceChannel.record.inventoryBatch": "庫存批次",
  "priceChannel.record.currentCombination": "當前組合",
  "priceChannel.record.latestQuote": "最新報價",
  "priceChannel.record.quoteTime": "報價時間",
  "priceChannel.record.inventoryMoq": "庫存 / MOQ",
  "priceChannel.record.packageCondition": "包裝 / 貨況",
  "priceChannel.record.tierCount": "{count} 檔",
  "priceChannel.record.batchHistory": "批次報價歷史",
  "priceChannel.record.noBatchHistory": "當前庫存批次還沒有已發佈報價",
  "priceChannel.record.intakeAndAi": "本次進件與 AI 預解析",
  "priceChannel.record.primaryCategory": "一級分類",
  "priceChannel.record.technologyFamily": "技術族",
  "priceChannel.record.uploaderConfirmation": "上傳方確認",
  "priceChannel.record.confirmedAt": "確認時間",
  "priceChannel.record.channelPartMapping": "渠道料號映射",
  "priceChannel.record.noAiResult": "本次進件尚未儲存 AI 預解析結果",
  "priceChannel.record.productIdentity": "產品身份",
  "priceChannel.record.productDescription": "產品説明",
  "priceChannel.record.noProductFacts": "該歷史記錄未儲存產品基礎資料",
  "priceChannel.record.unlinkedProduct": "待關聯產品",
  "priceChannel.record.pendingGeneration": "待生成",
  "priceChannel.record.unlinkedChannel": "待關聯渠道",
  "priceChannel.record.pendingRecognition": "待識別",
  "priceChannel.record.confirmed": "已確認",
  "priceChannel.record.reconfirm": "需重新確認",
  "priceChannel.record.pendingMapping": "待建立",
  "priceChannel.record.mapped": "已建立",
  "priceChannel.record.pendingReview": "待複核",
  "priceChannel.dimensionTrackAria": "行情維度軌道",
  "priceChannel.certReview.collapse": "收起",
  "priceChannel.certReview.expand": "展開",
  "priceChannel.certReview.disclosureAria": "{action}{name}企業認證資料",
  "priceChannel.certReview.materialsAria": "{name}企業認證資料",
  "priceChannel.certReview.waitingForOperations":
    "運營部審核中：領導可展開查看全部資料，暫不能終審。",
  "priceChannel.certReview.readyForFinal":
    "運營部已通過：現在可以執行領導終審。",
  "priceChannel.certReview.opinion": "審核意見",
  "priceChannel.certReview.opinionAria": "{name}審核意見",
  "priceChannel.certReview.waitingPlaceholder": "等待運營部完成審核",
  "priceChannel.certReview.reasonPlaceholder": "通過、退回或拒絕都必須説明理由",
  "priceChannel.certReview.disabledTitle": "等待運營部審核通過後開放",
  "priceChannel.certReview.finalApprove": "終審通過",
  "priceChannel.certReview.departmentApprove": "部門通過",
  "priceChannel.certReview.returnMaterials": "退回補件",
  "priceChannel.certReview.notProvided": "未填寫",
  "priceChannel.certReview.opinionRequired": "請先填寫審核意見",
  "priceChannel.account.currentIdentity": "價格頻道當前身份",
  "priceChannel.account.openMessages": "打開訊息中心",
  "priceChannel.account.messages": "訊息中心",
  "priceChannel.account.debugAccount": "調試賬號",
  "priceChannel.account.selectRoleGroup": "選擇角色類別",
  "priceChannel.account.selectDepartment": "選擇公司部門",
  "priceChannel.account.switchMember": "切換當前成員",
  "priceChannel.account.selectIdentity": "選擇當前業務身份",
  "priceChannel.api.localTargetRequired":
    "請先配置 VUE_APP_MTS_API_TARGET 指向本地 Spring Boot 服務",
  "priceChannel.api.requestFailed": "價格頻道請求失敗，請稍後重試",
  "priceChannel.api.unknownReviewAction": "未知審核動作",
  "priceChannel.api.error.UNAUTHENTICATED": "請先登入",
  "priceChannel.api.error.FORBIDDEN": "當前身份無此操作權限",
  "priceChannel.api.error.NOT_FOUND": "請求的內容不存在",
  "priceChannel.api.error.RELEASE_EXPIRED":
    "行情版本已過期，請刷新查看最新版本",
  "priceChannel.api.error.INVALID_ARGUMENT": "請求參數無效",
  "priceChannel.api.error.VERSION_CONFLICT": "版本已變化，請刷新後重試",
  "priceChannel.api.error.IDEMPOTENCY_CONFLICT": "相同請求標識對應的內容已變化",
  "priceChannel.api.error.PRICE_CHANNEL_UNAVAILABLE": "價格頻道暫不可用",
});

// 共用行情组件
export const sharedComponents = Object.freeze({
  "marketComponents.search": "搜索",
  "marketComponents.searchPlaceholder": "請輸入搜索內容",
  "marketComponents.viewProduct": "查看商品：{title}",
  "marketComponents.unnamedProduct": "未命名商品",
  "marketComponents.productImage": "商品圖片",
  "marketComponents.featured": "精選",
  "marketComponents.buy": "求",
  "marketComponents.brand": "品牌",
  "marketComponents.partNumber": "料號",
  "marketComponents.type": "類型",
  "marketComponents.capacity": "容量",
  "marketComponents.architecture": "架構",
  "marketComponents.speed": "速率",
  "marketComponents.ballCount": "球位",
  "marketComponents.price": "價格",
  "marketComponents.quantity": "數量",
  "marketComponents.publisher": "發佈人",
  "marketComponents.priceOnRequest": "價格面議",
  "marketComponents.totalAmount": "總金額 ¥{amount}",
  "marketComponents.payCommission": "支付佣金",
  "marketComponents.requestCancel": "申請取消",
  "marketComponents.confirmReceipt": "確認收貨",
  "marketComponents.review": "評價",
  "marketComponents.currencyUnit": "貨幣單位",
  "marketComponents.chooseCurrencyUnit": "選擇價格貨幣單位",
  "marketComponents.usDollar": "美元",
  "marketComponents.yuan": "人民幣",
});

export const messages = Object.freeze({
  ...businessDisplay,
  ...market,
  ...sharedComponents,
});

// 系统技术分类显示名；不修改原始分类与查询标识
export const catalogLabels = Object.freeze({
  晶圆: "晶圓",
  IC芯片: "IC 晶片",
  模组成品: "模組成品",
  技术族: "技術族",
  类型: "類型",
  制程: "製程",
  代际: "代際",
  容量: "容量",
  频率: "頻率",
  速率: "速率",
  位宽: "位寬",
  组织: "組織",
  层数: "層數",
  直径: "直徑",
  封装: "封裝",
  结构: "結構",
  协议: "協議",
  接口: "介面",
  形态: "形態",
  等级: "等級",
  闪存晶圆: "快閃記憶體晶圓",
  内存晶圆: "記憶體晶圓",
  闪存芯片: "快閃記憶體晶片",
  内存芯片: "記憶體晶片",
  嵌入式存储: "嵌入式儲存",
  嵌入式存储器: "嵌入式儲存器",
  固态硬盘: "固態硬碟",
  内存条: "記憶體模組",
  存储卡: "記憶卡",
  闪存卡: "快閃記憶卡",
  U盘: "USB閃存盤",
  USB闪存盘: "USB閃存盤",
  闪存盘: "閃存盤",
  白片方案: "白片方案",
  黑片高风险方案: "黑片高風險方案",
  其他SSD: "其他 SSD",
  "YMTC 长江存储": "YMTC 長江存儲",
  不适用: "不適用",
  "2.5英寸": "2.5 吋",
  消费级: "消費級",
  企业级: "企業級",
  工业级: "工業級",
  二级市场: "二級市場",
  高速: "高速",
  裸Die: "裸 Die",
  封装颗粒: "封裝晶片",
  单Die: "單 Die",
  多Die: "多 Die",
  管理封装: "管理封裝",
  TSV堆叠: "TSV 堆疊",
  USB大容量存储: "USB 大容量儲存",
});

// 冻结目录的机器代码显示名
export const catalogCodes = Object.freeze({
  "flash-wafer": "快閃記憶體晶圓",
  "memory-wafer": "記憶體晶圓",
  "flash-chip": "快閃記憶體晶片",
  "memory-chip": "記憶體晶片",
  "memory-module": "記憶體模組",
  "solid-state-drive": "固態硬碟",
  "flash-card": "快閃記憶卡",
  "embedded-storage": "嵌入式儲存器",
  "usb-flash-drive": "USB閃存盤",
  ymtc: "YMTC 長江存儲",
  "protocol-version": "協議",
  "speed-class": "等級",
  "form-factor": "形態",
  "byte-capacity-gbyte": "容量",
  "interface-generation": "介面",
  "ecc-capability": "ECC",
  "flash-cell-type": "製程",
  "wafer-device-kind": "類型",
  "flash-memory-kind": "類型",
  "dram-generation": "代際",
  "bit-density-gbit": "容量",
  "clock-mhz": "頻率",
  "data-rate-mtps": "速率",
  "bus-width": "位寬",
  organization: "組織",
  "stack-layer-count": "層數",
  "wafer-diameter-mm": "直徑",
  "interface-rate-mtps": "速率",
  package: "封裝",
  "package-structure": "結構",
  rank: "Rank",
  nvme: "NVMe",
  sata: "SATA",
  emmc: "eMMC",
  emcp: "eMCP",
  slc: "SLC",
  mlc: "MLC",
  tlc: "TLC",
  qlc: "QLC",
  "not-applicable": "不適用",
  ldpc: "LDPC",
  "sata-iii": "SATA III",
  "2.5-inch": "2.5 吋",
  consumer: "消費級",
  enterprise: "企業級",
  industrial: "工業級",
  "secondary-market": "二級市場",
  "high-speed": "高速",
  "bare-die": "裸 Die",
  "packaged-ic": "封裝晶片",
  "single-die": "單 Die",
  "multi-die": "多 Die",
  "managed-package": "管理封裝",
  "tsv-stack": "TSV 堆疊",
  "usb-mass-storage": "USB 大容量儲存",
  "unverified-white-batch": "白片方案",
  "unverified-black-batch": "黑片高風險方案",
});

// 已登记渠道展示参考译名；不是法定名称，未知企业保持原文
export const companyNames = Object.freeze({
  安庆存储通电子科技: "安慶存儲通電子科技",
  安庆科储半导体: "安慶科儲半導體",
  安庆芯拓电子商贸: "安慶芯拓電子商貿",
  安庆芯源电子供应链: "安慶芯源電子供應鏈",
  安阳存储通电子科技: "安陽存儲通電子科技",
  安阳科储半导体: "安陽科儲半導體",
  安阳芯拓电子商贸: "安陽芯拓電子商貿",
  安阳芯源电子供应链: "安陽芯源電子供應鏈",
  鞍山存储通电子科技: "鞍山存儲通電子科技",
  鞍山芯拓电子商贸: "鞍山芯拓電子商貿",
  鞍山芯源电子供应链: "鞍山芯源電子供應鏈",
  蚌埠存储通电子科技: "蚌埠存儲通電子科技",
  蚌埠科储半导体: "蚌埠科儲半導體",
  蚌埠芯源电子供应链: "蚌埠芯源電子供應鏈",
  宝鸡存储通电子科技: "寶雞存儲通電子科技",
  宝鸡科储半导体: "寶雞科儲半導體",
  宝鸡芯拓电子商贸: "寶雞芯拓電子商貿",
  宝鸡芯源电子供应链: "寶雞芯源電子供應鏈",
  保定存储通电子科技: "保定存儲通電子科技",
  保定科储半导体: "保定科儲半導體",
  保定芯源电子供应链: "保定芯源電子供應鏈",
  北海科储半导体: "北海科儲半導體",
  北海芯拓电子商贸: "北海芯拓電子商貿",
  北海芯源电子供应链: "北海芯源電子供應鏈",
  北京存储通电子科技: "北京存儲通電子科技",
  北京华储电子供应链有限公司: "北京華儲電子供應鏈有限公司",
  北京芯拓电子商贸: "北京芯拓電子商貿",
  北京芯源电子供应链: "北京芯源電子供應鏈",
  沧州存储通电子科技: "滄州存儲通電子科技",
  沧州科储半导体: "滄州科儲半導體",
  沧州芯拓电子商贸: "滄州芯拓電子商貿",
  沧州芯源电子供应链: "滄州芯源電子供應鏈",
  常德科储半导体: "常德科儲半導體",
  常德芯拓电子商贸: "常德芯拓電子商貿",
  常德芯源电子供应链: "常德芯源電子供應鏈",
  常州存储通电子科技: "常州存儲通電子科技",
  常州科储半导体: "常州科儲半導體",
  常州芯拓电子商贸: "常州芯拓電子商貿",
  成都存储通电子科技: "成都存儲通電子科技",
  成都科储半导体: "成都科儲半導體",
  成都芯源电子供应链: "成都芯源電子供應鏈",
  滁州存储通电子科技: "滁州存儲通電子科技",
  滁州芯拓电子商贸: "滁州芯拓電子商貿",
  滁州芯源电子供应链: "滁州芯源電子供應鏈",
  大连存储通电子科技: "大連存儲通電子科技",
  大连科储半导体: "大連科儲半導體",
  大连芯拓电子商贸: "大連芯拓電子商貿",
  丹东存储通电子科技: "丹東存儲通電子科技",
  丹东科储半导体: "丹東科儲半導體",
  丹东芯源电子供应链: "丹東芯源電子供應鏈",
  德阳存储通电子科技: "德陽存儲通電子科技",
  德阳科储半导体: "德陽科儲半導體",
  德阳芯拓电子商贸: "德陽芯拓電子商貿",
  德阳芯源电子供应链: "德陽芯源電子供應鏈",
  东莞存储通电子科技: "東莞存儲通電子科技",
  东莞芯拓电子商贸: "東莞芯拓電子商貿",
  东莞芯源电子供应链: "東莞芯源電子供應鏈",
  佛山科储半导体: "佛山科儲半導體",
  佛山芯拓电子商贸: "佛山芯拓電子商貿",
  佛山芯源电子供应链: "佛山芯源電子供應鏈",
  福州存储通电子科技: "福州存儲通電子科技",
  福州科储半导体: "福州科儲半導體",
  福州芯源电子供应链: "福州芯源電子供應鏈",
  赣州科储半导体: "贛州科儲半導體",
  赣州芯拓电子商贸: "贛州芯拓電子商貿",
  赣州芯源电子供应链: "贛州芯源電子供應鏈",
  广州存储通电子科技: "廣州存儲通電子科技",
  广州科储半导体: "廣州科儲半導體",
  广州悦沈电子科技: "廣州悅沈電子科技",
  桂林存储通电子科技: "桂林存儲通電子科技",
  桂林芯拓电子商贸: "桂林芯拓電子商貿",
  桂林芯源电子供应链: "桂林芯源電子供應鏈",
  邯郸科储半导体: "邯鄲科儲半導體",
  邯郸芯拓电子商贸: "邯鄲芯拓電子商貿",
  邯郸芯源电子供应链: "邯鄲芯源電子供應鏈",
  汉中存储通电子科技: "漢中存儲通電子科技",
  汉中芯拓电子商贸: "漢中芯拓電子商貿",
  汉中芯源电子供应链: "漢中芯源電子供應鏈",
  杭州存储通电子科技: "杭州存儲通電子科技",
  杭州科储半导体: "杭州科儲半導體",
  杭州芯源电子供应链: "杭州芯源電子供應鏈",
  合肥存储通电子科技: "合肥存儲通電子科技",
  合肥科储半导体: "合肥科儲半導體",
  合肥芯拓电子商贸: "合肥芯拓電子商貿",
  合肥芯源电子供应链: "合肥芯源電子供應鏈",
  衡阳存储通电子科技: "衡陽存儲通電子科技",
  衡阳芯拓电子商贸: "衡陽芯拓電子商貿",
  衡阳芯源电子供应链: "衡陽芯源電子供應鏈",
  华秋商城: "華秋商城",
  黄石科储半导体: "黃石科儲半導體",
  黄石芯拓电子商贸: "黃石芯拓電子商貿",
  黄石芯源电子供应链: "黃石芯源電子供應鏈",
  惠州存储通电子科技: "惠州存儲通電子科技",
  惠州科储半导体: "惠州科儲半導體",
  惠州芯拓电子商贸: "惠州芯拓電子商貿",
  惠州芯源电子供应链: "惠州芯源電子供應鏈",
  吉安科储半导体: "吉安科儲半導體",
  吉安芯拓电子商贸: "吉安芯拓電子商貿",
  吉安芯源电子供应链: "吉安芯源電子供應鏈",
  济南存储通电子科技: "濟南存儲通電子科技",
  济南芯拓电子商贸: "濟南芯拓電子商貿",
  济南芯源电子供应链: "濟南芯源電子供應鏈",
  嘉兴存储通电子科技: "嘉興存儲通電子科技",
  嘉兴科储半导体: "嘉興科儲半導體",
  嘉兴芯拓电子商贸: "嘉興芯拓電子商貿",
  嘉兴芯源电子供应链: "嘉興芯源電子供應鏈",
  金华存储通电子科技: "金華存儲通電子科技",
  金华科储半导体: "金華科儲半導體",
  金华芯拓电子商贸: "金華芯拓電子商貿",
  锦州存储通电子科技: "錦州存儲通電子科技",
  锦州科储半导体: "錦州科儲半導體",
  锦州芯拓电子商贸: "錦州芯拓電子商貿",
  荆州存储通电子科技: "荊州存儲通電子科技",
  荆州科储半导体: "荊州科儲半導體",
  荆州芯拓电子商贸: "荊州芯拓電子商貿",
  荆州芯源电子供应链: "荊州芯源電子供應鏈",
  九江存储通电子科技: "九江存儲通電子科技",
  九江科储半导体: "九江科儲半導體",
  九江芯拓电子商贸: "九江芯拓電子商貿",
  九江芯源电子供应链: "九江芯源電子供應鏈",
  廊坊存储通电子科技: "廊坊存儲通電子科技",
  廊坊科储半导体: "廊坊科儲半導體",
  廊坊芯拓电子商贸: "廊坊芯拓電子商貿",
  乐山存储通电子科技: "樂山存儲通電子科技",
  乐山科储半导体: "樂山科儲半導體",
  乐山芯源电子供应链: "樂山芯源電子供應鏈",
  立创商城: "立創商城",
  柳州存储通电子科技: "柳州存儲通電子科技",
  柳州科储半导体: "柳州科儲半導體",
  柳州芯拓电子商贸: "柳州芯拓電子商貿",
  柳州芯源电子供应链: "柳州芯源電子供應鏈",
  龙岩存储通电子科技: "龍岩存儲通電子科技",
  龙岩科储半导体: "龍岩科儲半導體",
  龙岩芯拓电子商贸: "龍岩芯拓電子商貿",
  洛阳存储通电子科技: "洛陽存儲通電子科技",
  洛阳科储半导体: "洛陽科儲半導體",
  洛阳芯拓电子商贸: "洛陽芯拓電子商貿",
  马鞍山存储通电子科技: "馬鞍山存儲通電子科技",
  马鞍山科储半导体: "馬鞍山科儲半導體",
  马鞍山芯拓电子商贸: "馬鞍山芯拓電子商貿",
  绵阳存储通电子科技: "綿陽存儲通電子科技",
  绵阳科储半导体: "綿陽科儲半導體",
  绵阳芯拓电子商贸: "綿陽芯拓電子商貿",
  南昌存储通电子科技: "南昌存儲通電子科技",
  南昌芯拓电子商贸: "南昌芯拓電子商貿",
  南昌芯源电子供应链: "南昌芯源電子供應鏈",
  南充存储通电子科技: "南充存儲通電子科技",
  南充科储半导体: "南充科儲半導體",
  南充芯拓电子商贸: "南充芯拓電子商貿",
  南京存储通电子科技: "南京存儲通電子科技",
  南京芯拓电子商贸: "南京芯拓電子商貿",
  南京芯源电子供应链: "南京芯源電子供應鏈",
  南宁存储通电子科技: "南寧存儲通電子科技",
  南宁科储半导体: "南寧科儲半導體",
  南宁芯源电子供应链: "南寧芯源電子供應鏈",
  南通存储通电子科技: "南通存儲通電子科技",
  南通科储半导体: "南通科儲半導體",
  南通芯拓电子商贸: "南通芯拓電子商貿",
  南通芯源电子供应链: "南通芯源電子供應鏈",
  南阳存储通电子科技: "南陽存儲通電子科技",
  南阳科储半导体: "南陽科儲半導體",
  南阳芯源电子供应链: "南陽芯源電子供應鏈",
  宁波存储通电子科技: "寧波存儲通電子科技",
  宁波科储半导体: "寧波科儲半導體",
  宁波芯拓电子商贸: "寧波芯拓電子商貿",
  莆田存储通电子科技: "莆田存儲通電子科技",
  莆田科储半导体: "莆田科儲半導體",
  莆田芯源电子供应链: "莆田芯源電子供應鏈",
  青岛科储半导体: "青島科儲半導體",
  青岛芯拓电子商贸: "青島芯拓電子商貿",
  青岛芯源电子供应链: "青島芯源電子供應鏈",
  泉州存储通电子科技: "泉州存儲通電子科技",
  泉州芯拓电子商贸: "泉州芯拓電子商貿",
  泉州芯源电子供应链: "泉州芯源電子供應鏈",
  厦门存储通电子科技: "廈門存儲通電子科技",
  厦门科储半导体: "廈門科儲半導體",
  厦门芯拓电子商贸: "廈門芯拓電子商貿",
  厦门芯源电子供应链: "廈門芯源電子供應鏈",
  上海科储半导体: "上海科儲半導體",
  上海芯拓电子商贸: "上海芯拓電子商貿",
  上海芯途电子科技有限公司: "上海芯途電子科技有限公司",
  上海芯源电子供应链: "上海芯源電子供應鏈",
  上饶存储通电子科技: "上饒存儲通電子科技",
  上饶科储半导体: "上饒科儲半導體",
  上饶芯拓电子商贸: "上饒芯拓電子商貿",
  绍兴存储通电子科技: "紹興存儲通電子科技",
  绍兴科储半导体: "紹興科儲半導體",
  绍兴芯源电子供应链: "紹興芯源電子供應鏈",
  深圳存储通电子科技: "深圳存儲通電子科技",
  深圳科储半导体: "深圳科儲半導體",
  深圳芯源电子供应链: "深圳芯源電子供應鏈",
  沈阳存储通电子科技: "瀋陽存儲通電子科技",
  沈阳科储半导体: "瀋陽科儲半導體",
  沈阳芯源电子供应链: "瀋陽芯源電子供應鏈",
  石家庄存储通电子科技: "石家莊存儲通電子科技",
  石家庄芯拓电子商贸: "石家莊芯拓電子商貿",
  石家庄芯源电子供应链: "石家莊芯源電子供應鏈",
  世强硬创: "世強硬創",
  苏州科储半导体: "蘇州科儲半導體",
  苏州芯拓电子商贸: "蘇州芯拓電子商貿",
  苏州芯源电子供应链: "蘇州芯源電子供應鏈",
  唐山科储半导体: "唐山科儲半導體",
  唐山芯拓电子商贸: "唐山芯拓電子商貿",
  唐山芯源电子供应链: "唐山芯源電子供應鏈",
  威海科储半导体: "威海科儲半導體",
  威海芯拓电子商贸: "威海芯拓電子商貿",
  威海芯源电子供应链: "威海芯源電子供應鏈",
  潍坊存储通电子科技: "濰坊存儲通電子科技",
  潍坊科储半导体: "濰坊科儲半導體",
  潍坊芯拓电子商贸: "濰坊芯拓電子商貿",
  渭南存储通电子科技: "渭南存儲通電子科技",
  渭南科储半导体: "渭南科儲半導體",
  渭南芯拓电子商贸: "渭南芯拓電子商貿",
  温州存储通电子科技: "溫州存儲通電子科技",
  温州芯拓电子商贸: "溫州芯拓電子商貿",
  温州芯源电子供应链: "溫州芯源電子供應鏈",
  无锡存储通电子科技: "無錫存儲通電子科技",
  无锡科储半导体: "無錫科儲半導體",
  无锡芯源电子供应链: "無錫芯源電子供應鏈",
  芜湖科储半导体: "蕪湖科儲半導體",
  芜湖芯拓电子商贸: "蕪湖芯拓電子商貿",
  芜湖芯源电子供应链: "蕪湖芯源電子供應鏈",
  梧州存储通电子科技: "梧州存儲通電子科技",
  梧州科储半导体: "梧州科儲半導體",
  梧州芯拓电子商贸: "梧州芯拓電子商貿",
  武汉存储通电子科技: "武漢存儲通電子科技",
  武汉科储半导体: "武漢科儲半導體",
  武汉芯源电子供应链: "武漢芯源電子供應鏈",
  西安存储通电子科技: "西安存儲通電子科技",
  西安芯拓电子商贸: "西安芯拓電子商貿",
  西安芯源电子供应链: "西安芯源電子供應鏈",
  咸阳存储通电子科技: "咸陽存儲通電子科技",
  咸阳科储半导体: "咸陽科儲半導體",
  咸阳芯源电子供应链: "咸陽芯源電子供應鏈",
  湘潭存储通电子科技: "湘潭存儲通電子科技",
  湘潭科储半导体: "湘潭科儲半導體",
  湘潭芯源电子供应链: "湘潭芯源電子供應鏈",
  襄阳存储通电子科技: "襄陽存儲通電子科技",
  襄阳芯拓电子商贸: "襄陽芯拓電子商貿",
  襄阳芯源电子供应链: "襄陽芯源電子供應鏈",
  孝感存储通电子科技: "孝感存儲通電子科技",
  孝感科储半导体: "孝感科儲半導體",
  孝感芯拓电子商贸: "孝感芯拓電子商貿",
  新乡存储通电子科技: "新鄉存儲通電子科技",
  新乡芯拓电子商贸: "新鄉芯拓電子商貿",
  新乡芯源电子供应链: "新鄉芯源電子供應鏈",
  许昌科储半导体: "許昌科儲半導體",
  许昌芯拓电子商贸: "許昌芯拓電子商貿",
  许昌芯源电子供应链: "許昌芯源電子供應鏈",
  烟台存储通电子科技: "煙台存儲通電子科技",
  烟台科储半导体: "煙台科儲半導體",
  烟台芯拓电子商贸: "煙台芯拓電子商貿",
  烟台芯源电子供应链: "煙台芯源電子供應鏈",
  扬州科储半导体: "揚州科儲半導體",
  扬州芯拓电子商贸: "揚州芯拓電子商貿",
  扬州芯源电子供应链: "揚州芯源電子供應鏈",
  宜宾科储半导体: "宜賓科儲半導體",
  宜宾芯拓电子商贸: "宜賓芯拓電子商貿",
  宜宾芯源电子供应链: "宜賓芯源電子供應鏈",
  宜昌存储通电子科技: "宜昌存儲通電子科技",
  宜昌科储半导体: "宜昌科儲半導體",
  宜昌芯拓电子商贸: "宜昌芯拓電子商貿",
  宜春存储通电子科技: "宜春存儲通電子科技",
  宜春芯拓电子商贸: "宜春芯拓電子商貿",
  宜春芯源电子供应链: "宜春芯源電子供應鏈",
  营口存储通电子科技: "營口存儲通電子科技",
  营口科储半导体: "營口科儲半導體",
  营口芯拓电子商贸: "營口芯拓電子商貿",
  营口芯源电子供应链: "營口芯源電子供應鏈",
  榆林科储半导体: "榆林科儲半導體",
  榆林芯拓电子商贸: "榆林芯拓電子商貿",
  榆林芯源电子供应链: "榆林芯源電子供應鏈",
  玉林存储通电子科技: "玉林存儲通電子科技",
  玉林科储半导体: "玉林科儲半導體",
  玉林芯源电子供应链: "玉林芯源電子供應鏈",
  岳阳存储通电子科技: "岳陽存儲通電子科技",
  岳阳科储半导体: "岳陽科儲半導體",
  岳阳芯拓电子商贸: "岳陽芯拓電子商貿",
  岳阳芯源电子供应链: "岳陽芯源電子供應鏈",
  云汉芯城: "雲漢芯城",
  漳州科储半导体: "漳州科儲半導體",
  漳州芯拓电子商贸: "漳州芯拓電子商貿",
  漳州芯源电子供应链: "漳州芯源電子供應鏈",
  长沙存储通电子科技: "長沙存儲通電子科技",
  长沙芯拓电子商贸: "長沙芯拓電子商貿",
  长沙芯源电子供应链: "長沙芯源電子供應鏈",
  郑州存储通电子科技: "鄭州存儲通電子科技",
  郑州科储半导体: "鄭州科儲半導體",
  郑州芯拓电子商贸: "鄭州芯拓電子商貿",
  郑州芯源电子供应链: "鄭州芯源電子供應鏈",
  株洲科储半导体: "株洲科儲半導體",
  株洲芯拓电子商贸: "株洲芯拓電子商貿",
  株洲芯源电子供应链: "株洲芯源電子供應鏈",
  珠海存储通电子科技: "珠海存儲通電子科技",
  珠海科储半导体: "珠海科儲半導體",
  珠海芯源电子供应链: "珠海芯源電子供應鏈",
  淄博存储通电子科技: "淄博存儲通電子科技",
  淄博芯拓电子商贸: "淄博芯拓電子商貿",
  淄博芯源电子供应链: "淄博芯源電子供應鏈",
  XSOU专属报价: "XSOU 專屬報價",
});

// 已登记产品显示名；不修改料号、产品身份与风险等级
export const productNames = Object.freeze({
  "ADATA USB闪存盘 128GB": "ADATA USB閃存盤 128GB",
  "CXMT DDR4 16Gb x8 晶圆Demo": "CXMT DDR4 16Gb x8 晶圓Demo",
  "CXMT DDR4 8Gb x8 晶圆Demo": "CXMT DDR4 8Gb x8 晶圓Demo",
  "CXMT DDR5 16Gb x8 晶圆Demo": "CXMT DDR5 16Gb x8 晶圓Demo",
  "Intel 144L QLC 1Tb 晶圆Demo": "Intel 144L QLC 1Tb 晶圓Demo",
  "KIOXIA BiCS5 TLC 512Gb 晶圆Demo": "KIOXIA BiCS5 TLC 512Gb 晶圓Demo",
  "KIOXIA BiCS6 TLC 1Tb 晶圆Demo": "KIOXIA BiCS6 TLC 1Tb 晶圓Demo",
  "KIOXIA USB闪存盘 128GB": "KIOXIA USB閃存盤 128GB",
  "KIOXIA 企业级 SSD 2TB": "KIOXIA 企業級 SSD 2TB",
  "Kingston USB闪存盘 128GB": "Kingston USB閃存盤 128GB",
  "Lexar USB闪存盘 128GB": "Lexar USB閃存盤 128GB",
  "Macronix MX30 MLC 8Gb 晶圆Demo": "Macronix MX30 MLC 8Gb 晶圓Demo",
  "Micron B47R TLC 512Gb 晶圆Demo": "Micron B47R TLC 512Gb 晶圓Demo",
  "Micron B58R TLC 1Tb 晶圆Demo": "Micron B58R TLC 1Tb 晶圓Demo",
  "Micron DDR5 16Gb x8 晶圆Demo": "Micron DDR5 16Gb x8 晶圓Demo",
  "Micron DDR5 32Gb x8 晶圆Demo": "Micron DDR5 32Gb x8 晶圓Demo",
  "Micron HBM2E 8Gb x4 晶圆Demo": "Micron HBM2E 8Gb x4 晶圓Demo",
  "Micron LPDDR5 16Gb x16 晶圆Demo": "Micron LPDDR5 16Gb x16 晶圓Demo",
  "Micron 企业级 SSD 2TB": "Micron 企業級 SSD 2TB",
  "Nanya DDR4 8Gb x8 晶圆Demo": "Nanya DDR4 8Gb x8 晶圓Demo",
  "Nanya DDR5 16Gb x8 晶圆Demo": "Nanya DDR5 16Gb x8 晶圓Demo",
  "Netac USB闪存盘 128GB": "Netac USB閃存盤 128GB",
  "PNY USB闪存盘 128GB": "PNY USB閃存盤 128GB",
  "SK hynix DDR5 16Gb x8 晶圆Demo": "SK hynix DDR5 16Gb x8 晶圓Demo",
  "SK hynix DDR5 24Gb x8 晶圆Demo": "SK hynix DDR5 24Gb x8 晶圓Demo",
  "SK hynix HBM3 16Gb x4 晶圆Demo": "SK hynix HBM3 16Gb x4 晶圓Demo",
  "SK hynix V7 TLC 512Gb 晶圆Demo": "SK hynix V7 TLC 512Gb 晶圓Demo",
  "SK hynix V8 QLC 1Tb 晶圆Demo": "SK hynix V8 QLC 1Tb 晶圓Demo",
  "Samsung DDR5 16Gb x8 晶圆Demo": "Samsung DDR5 16Gb x8 晶圓Demo",
  "Samsung DDR5 24Gb x8 晶圆Demo": "Samsung DDR5 24Gb x8 晶圓Demo",
  "Samsung HBM3E 24Gb x4 晶圆Demo": "Samsung HBM3E 24Gb x4 晶圓Demo",
  "Samsung LPDDR5 16Gb x16 晶圆Demo": "Samsung LPDDR5 16Gb x16 晶圓Demo",
  "Samsung USB闪存盘 128GB": "Samsung USB閃存盤 128GB",
  "Samsung V6 TLC 512Gb 晶圆Demo": "Samsung V6 TLC 512Gb 晶圓Demo",
  "Samsung V7 TLC 512Gb 晶圆Demo": "Samsung V7 TLC 512Gb 晶圓Demo",
  "Samsung V8 TLC 1Tb 晶圆Demo": "Samsung V8 TLC 1Tb 晶圓Demo",
  "Samsung 企业级 SSD 2TB": "Samsung 企業級 SSD 2TB",
  "SanDisk BiCS5 TLC 512Gb 晶圆Demo": "SanDisk BiCS5 TLC 512Gb 晶圓Demo",
  "SanDisk USB闪存盘 128GB": "SanDisk USB閃存盤 128GB",
  "Seagate 企业级 SSD 2TB": "Seagate 企業級 SSD 2TB",
  "SpecTek DDR4 8Gb x8 重构晶圆Demo": "SpecTek DDR4 8Gb x8 重構晶圓Demo",
  "SpecTek E0 TLC 256Gb 重构晶圆Demo": "SpecTek E0 TLC 256Gb 重構晶圓Demo",
  "Teclast USB闪存盘 128GB": "Teclast USB閃存盤 128GB",
  "Transcend USB闪存盘 128GB": "Transcend USB閃存盤 128GB",
  "Winbond DDR3 4Gb x16 晶圆Demo": "Winbond DDR3 4Gb x16 晶圓Demo",
  "Winbond DDR4 8Gb x16 晶圆Demo": "Winbond DDR4 8Gb x16 晶圓Demo",
  "Winbond W25N SLC 4Gb 晶圆Demo": "Winbond W25N SLC 4Gb 晶圓Demo",
  "Winbond W25Q NOR 2Gb 晶圆Demo": "Winbond W25Q NOR 2Gb 晶圓Demo",
  "YMTC X1-9050 TLC 256Gb 晶圆Demo": "YMTC X1-9050 TLC 256Gb 晶圓Demo",
  "YMTC X2-9060 TLC 512Gb 晶圆Demo": "YMTC X2-9060 TLC 512Gb 晶圓Demo",
  "YMTC X3-9060 TLC 512Gb 晶圆Demo": "YMTC X3-9060 TLC 512Gb 晶圓Demo",
  "YMTC X3-9070 TLC 1Tb 晶圆Demo": "YMTC X3-9070 TLC 1Tb 晶圓Demo",
  "白片 TLC 512Gb": "白片 TLC 512Gb",
  "白片口径 DDR4 8Gb (1Gx8)": "白片口徑 DDR4 8Gb (1Gx8)",
  "白片口径 DDR4 UDIMM 16GB": "白片口徑 DDR4 UDIMM 16GB",
  "白片颗粒方案 MicroSD 128GB": "白片顆粒方案 MicroSD 128GB",
  "白片颗粒方案 SATA SSD 512GB": "白片顆粒方案 SATA SSD 512GB",
  "白片颗粒方案 USB闪存盘 128GB": "白片顆粒方案 USB閃存盤 128GB",
  "白片颗粒方案 eMMC 64GB": "白片顆粒方案 eMMC 64GB",
  "黑片/回收颗粒风险 SATA SSD 512GB": "黑片/回收顆粒風險 SATA SSD 512GB",
  "黑片/回收颗粒风险 eMMC 64GB": "黑片/回收顆粒風險 eMMC 64GB",
  "黑片/打磨颗粒风险 DDR4 UDIMM 16GB": "黑片/打磨顆粒風險 DDR4 UDIMM 16GB",
  "黑片/扩容风险 MicroSD 128GB": "黑片/擴容風險 MicroSD 128GB",
  "黑片/扩容风险 USB闪存盘 128GB": "黑片/擴容風險 USB閃存盤 128GB",
  "黑片风险 DDR4 8Gb (1Gx8)": "黑片風險 DDR4 8Gb (1Gx8)",
  "黑片高风险 TLC 512Gb": "黑片高風險 TLC 512Gb",
});

// 系统地理目录显示名；不转换公司名、自由地址或数据库原文
export const regionNames = Object.freeze({
  中国: "中國",
  北京: "北京",
  上海: "上海",
  香港: "香港",
  澳门: "澳門",
  广东: "廣東",
  深圳: "深圳",
  广州: "廣州",
  东莞: "東莞",
  佛山: "佛山",
  珠海: "珠海",
  惠州: "惠州",
  江苏: "江蘇",
  南京: "南京",
  苏州: "蘇州",
  无锡: "無錫",
  常州: "常州",
  南通: "南通",
  扬州: "揚州",
  浙江: "浙江",
  杭州: "杭州",
  宁波: "寧波",
  温州: "溫州",
  嘉兴: "嘉興",
  绍兴: "紹興",
  金华: "金華",
  山东: "山東",
  济南: "濟南",
  青岛: "青島",
  烟台: "煙台",
  潍坊: "濰坊",
  淄博: "淄博",
  威海: "威海",
  福建: "福建",
  福州: "福州",
  厦门: "廈門",
  泉州: "泉州",
  漳州: "漳州",
  莆田: "莆田",
  龙岩: "龍岩",
  安徽: "安徽",
  合肥: "合肥",
  芜湖: "蕪湖",
  蚌埠: "蚌埠",
  马鞍山: "馬鞍山",
  滁州: "滁州",
  安庆: "安慶",
  湖北: "湖北",
  武汉: "武漢",
  宜昌: "宜昌",
  襄阳: "襄陽",
  黄石: "黃石",
  荆州: "荊州",
  孝感: "孝感",
  湖南: "湖南",
  长沙: "長沙",
  株洲: "株洲",
  湘潭: "湘潭",
  岳阳: "岳陽",
  衡阳: "衡陽",
  常德: "常德",
  四川: "四川",
  成都: "成都",
  绵阳: "綿陽",
  德阳: "德陽",
  宜宾: "宜賓",
  乐山: "樂山",
  南充: "南充",
  陕西: "陝西",
  西安: "西安",
  宝鸡: "寶雞",
  咸阳: "咸陽",
  渭南: "渭南",
  汉中: "漢中",
  榆林: "榆林",
  河南: "河南",
  郑州: "鄭州",
  洛阳: "洛陽",
  新乡: "新鄉",
  许昌: "許昌",
  南阳: "南陽",
  安阳: "安陽",
  河北: "河北",
  石家庄: "石家莊",
  唐山: "唐山",
  保定: "保定",
  廊坊: "廊坊",
  沧州: "滄州",
  邯郸: "邯鄲",
  辽宁: "遼寧",
  沈阳: "瀋陽",
  大连: "大連",
  鞍山: "鞍山",
  营口: "營口",
  丹东: "丹東",
  锦州: "錦州",
  江西: "江西",
  南昌: "南昌",
  赣州: "贛州",
  九江: "九江",
  上饶: "上饒",
  宜春: "宜春",
  吉安: "吉安",
  广西: "廣西",
  南宁: "南寧",
  柳州: "柳州",
  桂林: "桂林",
  北海: "北海",
  玉林: "玉林",
  梧州: "梧州",
  美国: "美國",
  加利福尼亚州: "加利福尼亞州",
  洛杉矶: "洛杉磯",
  旧金山: "三藩市",
  圣何塞: "聖何塞",
  得克萨斯州: "德克薩斯州",
  奥斯汀: "奧斯汀",
  达拉斯: "達拉斯",
  休斯敦: "侯斯頓",
  纽约州: "紐約州",
  纽约: "紐約",
  布法罗: "水牛城",
  奥尔巴尼: "奧爾巴尼",
  日本: "日本",
  东京都: "東京都",
  八王子: "八王子",
  町田: "町田",
  立川: "立川",
  大阪府: "大阪府",
  大阪: "大阪",
  堺: "堺",
  吹田: "吹田",
  爱知县: "愛知縣",
  名古屋: "名古屋",
  丰田: "豐田",
  冈崎: "岡崎",
  新加坡: "新加坡",
  中区: "中區",
  碧山: "碧山",
  女皇镇: "女皇鎮",
  大巴窑: "大巴窯",
  东区: "東區",
  淡滨尼: "淡濱尼",
  勿洛: "勿洛",
  巴西立: "巴西立",
  西区: "西區",
  裕廊东: "裕廊東",
  裕廊西: "裕廊西",
  金文泰: "金文泰",
  "归属未知（演示）": "歸屬未知（演示）",
});
